webpackJsonp([0],{

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaleLoader__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_SearchInput__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_SearchInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_SearchInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NoResults__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SearchFailure__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_css__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_css__);
















var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__NoResults__["a" /* default */], {});

var SearchMenuItems =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SearchMenuItems, _PureComponent);

  function SearchMenuItems() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, SearchMenuItems);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SearchMenuItems).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SearchMenuItems, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          loading = _this$props.loading;

      if (!loading && __WEBPACK_IMPORTED_MODULE_7_react__["Children"].count(children) === 0) {
        return _ref;
      }

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__StaleLoader__["a" /* default */], {
        loading: loading
      }, void 0, children);
    }
  }]);

  return SearchMenuItems;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SearchMenuItems, "propTypes", {
  loading: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node
});

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus__["Separator"], {});

var SearchMenuInput =
/*#__PURE__*/
function (_PureComponent2) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SearchMenuInput, _PureComponent2);

  function SearchMenuInput() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, SearchMenuInput);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SearchMenuInput).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SearchMenuInput, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Fragment, {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_14__styles_css___default.a.searchInput
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_SearchInput___default.a, {
        onChange: this.props.onChange
      })), _ref2);
    }
  }]);

  return SearchMenuInput;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SearchMenuInput, "propTypes", {
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired
});

var SearchMenu =
/*#__PURE__*/
function (_PureComponent3) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SearchMenu, _PureComponent3);

  function SearchMenu() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, SearchMenu);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SearchMenu).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SearchMenu, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return SearchMenu;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SearchMenu, "Input", SearchMenuInput);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SearchMenu, "Items", SearchMenuItems);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SearchMenu, "SearchFailure", __WEBPACK_IMPORTED_MODULE_13__SearchFailure__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SearchMenu, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node.isRequired
});



/***/ }),

/***/ 114:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"searchInput":"_-src-components-FilterMenu-styles---searchInput---1EcJ_","menu":"_-src-components-FilterMenu-styles---menu---Wk7w_","authorEmail":"_-src-components-FilterMenu-styles---authorEmail---3LqWF","messageItem":"_-src-components-FilterMenu-styles---messageItem---YcdtZ","noResults":"_-src-components-FilterMenu-styles---noResults---2mC8J _-src-components-FilterMenu-styles---messageItem---YcdtZ","searchFailure":"_-src-components-FilterMenu-styles---searchFailure---DthpF _-src-components-FilterMenu-styles---messageItem---YcdtZ"};

/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var steps = ["frequency", "segment", "notification", "review"];
/* harmony default export */ __webpack_exports__["a"] = (steps);

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var validateRuleName = function validateRuleName(ruleName) {
  return Boolean(ruleName);
};

/* harmony default export */ __webpack_exports__["a"] = (validateRuleName);

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateDirtyStateMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateDirtyState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);

var updateDirtyStateMutation = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "updateDirtyState"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "data"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Object"
          }
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "updateDirtyState"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "data"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "data"
            }
          }
        }],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }]
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 93,
    "source": {
      "body": "\n  mutation updateDirtyState($data: Object!) {\n    updateDirtyState(data: $data) @client\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var updateDirtyState = function updateDirtyState(_, _ref, _ref2) {
  var data = _ref.data;
  var cache = _ref2.cache;
  cache.writeData({
    data: {
      dirtyState: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({
        __typename: "DirtyState"
      }, data)
    }
  });
  return null;
};

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var yesNoFilters = ["isPromoted", "isOpenForComment"];
/* harmony default export */ __webpack_exports__["a"] = (yesNoFilters);

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoaderPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_loaders__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_loaders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_loaders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_css__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_css__);












var LoaderPanel =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(LoaderPanel, _PureComponent);

  function LoaderPanel() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, LoaderPanel);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(LoaderPanel).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(LoaderPanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          delayMS = _this$props.delayMS,
          testId = _this$props.testId;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_10__styles_css___default.a.loader
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_loaders__["Dots"], {
        delayMS: delayMS,
        "data-test-id": testId
      }));
    }
  }]);

  return LoaderPanel;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(LoaderPanel, "propTypes", {
  testId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  delayMS: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number
});



/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addFilterMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_yesNoFilters__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_createFilter__ = __webpack_require__(325);


var addFilterMutation = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "addFilter"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "type"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "value"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "addFilter"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "type"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "type"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "value"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "value"
            }
          }
        }],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }]
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 111,
    "source": {
      "body": "\n  mutation addFilter($type: String!, $value: String!) {\n    addFilter(type: $type, value: $value) @client\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var dirtyStateQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "dirtyState"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "filters"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "type"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "value"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 108,
    "source": {
      "body": "\n  query {\n    dirtyState @client {\n      filters {\n        id\n        type\n        value\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var addFilter = function addFilter(_, _ref, _ref2) {
  var type = _ref.type,
      value = _ref.value;
  var cache = _ref2.cache;

  var _cache$readQuery = cache.readQuery({
    query: dirtyStateQuery
  }),
      dirtyState = _cache$readQuery.dirtyState;

  var newFilter = Object(__WEBPACK_IMPORTED_MODULE_1__state_createFilter__["a" /* default */])({
    type: type,
    value: value
  });
  var duplicate = dirtyState.filters.find(function (filter) {
    return filter.type === type && filter.value === value;
  });

  if (duplicate) {
    return null;
  }

  var newFilters = __WEBPACK_IMPORTED_MODULE_0__state_yesNoFilters__["a" /* default */].includes(type) ? dirtyState.filters.filter(function (filter) {
    return filter.type !== type;
  }).concat(newFilter) : dirtyState.filters.concat(newFilter);
  var data = {
    dirtyState: {
      __typename: "DirtyState",
      filters: newFilters
    },
    articleMatchesPage: 1
  };
  cache.writeData({
    data: data
  });
  return null;
};

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Filter__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mutations_removeFilterMutation__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_css__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_css__);















var dirtyStateQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "dirtyState"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "filters"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "type"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "value"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 108,
    "source": {
      "body": "\n  query {\n    dirtyState @client {\n      filters {\n        id\n        type\n        value\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var FilterList =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(FilterList, _Component);

  function FilterList() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, FilterList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(FilterList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {});

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(FilterList, [{
    key: "render",
    value: function render() {
      var removable = this.props.removable;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Query"], {
        query: dirtyStateQuery
      }, void 0, function (_ref) {
        var dirtyState = _ref.data.dirtyState;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
          dir: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default.a.dir,
          className: __WEBPACK_IMPORTED_MODULE_14__styles_css___default.a.filters,
          "data-test-id": "filters"
        }, void 0, dirtyState.filters.map(function (_ref2) {
          var id = _ref2.id,
              type = _ref2.type,
              value = _ref2.value;
          return removable ? __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Mutation"], {
            mutation: __WEBPACK_IMPORTED_MODULE_12__mutations_removeFilterMutation__["b" /* removeFilterMutation */],
            variables: {
              id: id
            }
          }, id, function (mutate) {
            return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__Filter__["a" /* default */], {
              onClick: mutate,
              type: type,
              value: value
            });
          }) : __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__Filter__["a" /* default */], {
            type: type,
            value: value
          }, id);
        }));
      });
    }
  }]);

  return FilterList;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(FilterList, "propTypes", {
  removable: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.bool
});



/***/ }),

/***/ 217:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_-src-components-ArticleMatches-styles---container---3g6pA","title":"_-src-components-ArticleMatches-styles---title---2hgyM","table":"_-src-components-ArticleMatches-styles---table---1n2SO","ellipsis":"_-src-components-ArticleMatches-styles---ellipsis---2GwVP","cell":"_-src-components-ArticleMatches-styles---cell---y6dWm","message":"_-src-components-ArticleMatches-styles---message---1GURc","noResults":"_-src-components-ArticleMatches-styles---noResults---1TXiv _-src-components-ArticleMatches-styles---message---1GURc","searchFailure":"_-src-components-ArticleMatches-styles---searchFailure---3SN5R _-src-components-ArticleMatches-styles---message---1GURc"};

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupby__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_groupby__);




var prepareFilters = function prepareFilters(filters) {
  var filtersByType = __WEBPACK_IMPORTED_MODULE_2_lodash_groupby___default()(filters, "type");
  return ["author", "brand", "origin", "isOpenForComment", "isPromoted", "label", "created", "updated", "permissionGroup", "userSegment", "category", "section"].reduce(function (result, key) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, result, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, key, (filtersByType[key] || []).map(function (_ref) {
      var value = _ref.value;
      return value;
    })));
  }, {});
};

/* harmony default export */ __webpack_exports__["a"] = (prepareFilters);

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createVerificationRuleMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateVerificationRuleMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteVerificationRuleMutation; });
var createVerificationRuleMutation = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "createVerificationRule"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "name"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "filter"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "CreateVerificationRuleFilterInput"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "frequency"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "VerificationRuleFrequency"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "notification"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "CreateVerificationRuleNotificationInput"
          }
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "createVerificationRule"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "name"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "name"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "filter"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "filter"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "frequency"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "frequency"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "notification"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "notification"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "success"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 374,
    "source": {
      "body": "\n  mutation createVerificationRule(\n    $name: String!\n    $filter: CreateVerificationRuleFilterInput!\n    $frequency: VerificationRuleFrequency!\n    $notification: CreateVerificationRuleNotificationInput!\n  ) {\n    createVerificationRule(\n      name: $name\n      filter: $filter\n      frequency: $frequency\n      notification: $notification\n    ) {\n      success\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var updateVerificationRuleMutation = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "updateVerificationRule"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ID"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "name"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "filter"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "UpdateVerificationRuleFilterInput"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "frequency"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "VerificationRuleFrequency"
          }
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "notification"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "UpdateVerificationRuleNotificationInput"
          }
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "updateVerificationRule"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "id"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "name"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "name"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "filter"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "filter"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "frequency"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "frequency"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "notification"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "notification"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "success"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 401,
    "source": {
      "body": "\n  mutation updateVerificationRule(\n    $id: ID!\n    $name: String!\n    $filter: UpdateVerificationRuleFilterInput!\n    $frequency: VerificationRuleFrequency!\n    $notification: UpdateVerificationRuleNotificationInput!\n  ) {\n    updateVerificationRule(\n      id: $id\n      name: $name\n      filter: $filter\n      frequency: $frequency\n      notification: $notification\n    ) {\n      success\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var deleteVerificationRuleMutation = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "deleteVerificationRuleMutation"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ID"
          }
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "deleteVerificationRule"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "id"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "success"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 117,
    "source": {
      "body": "\n  mutation deleteVerificationRuleMutation($id: ID!) {\n    deleteVerificationRule(id: $id) {\n      success\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MutationWithOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);













var MutationWithOverlay =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(MutationWithOverlay, _PureComponent);

  function MutationWithOverlay() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, MutationWithOverlay);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(MutationWithOverlay)).call.apply(_getPrototypeOf2, [this].concat(_args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "mutate", function (mutate, mutationResult) {
      var children = _this.props.children;
      var client = mutationResult.client;
      return children(
      /*#__PURE__*/
      __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(
      /*#__PURE__*/
      __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.mark(function _callee() {
        var _args2 = arguments;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                client.writeData({
                  data: {
                    showLoadingOverlay: true
                  }
                });
                _context.prev = 1;
                _context.next = 4;
                return mutate.apply(void 0, _args2);

              case 4:
                _context.prev = 4;
                client.writeData({
                  data: {
                    showLoadingOverlay: false
                  }
                });
                return _context.finish(4);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1,, 4, 7]]);
      })), mutationResult);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(MutationWithOverlay, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Mutation"], this.props, this.mutate);
    }
  }]);

  return MutationWithOverlay;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(MutationWithOverlay, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired
});



/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_client__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_link__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link_http__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_link_error__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apollo_link_state__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__zendesk_knowledge_context__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__zendesk_knowledge_utils_lib_redirectToSignIn__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__zendesk_knowledge_utils_lib_redirectToSignIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__zendesk_knowledge_utils_lib_redirectToSignIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resolvers__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__state_defaults__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fragmentTypes_json__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fragmentTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__fragmentTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_apollo_cache_inmemory__ = __webpack_require__(883);












var fragmentMatcher = new __WEBPACK_IMPORTED_MODULE_11_apollo_cache_inmemory__["b" /* IntrospectionFragmentMatcher */]({
  introspectionQueryResultData: __WEBPACK_IMPORTED_MODULE_10__fragmentTypes_json___default.a
});
var cache = new __WEBPACK_IMPORTED_MODULE_11_apollo_cache_inmemory__["a" /* InMemoryCache */]({
  fragmentMatcher: fragmentMatcher,
  // Since we use global ids which already contain type information
  // we can tell Apollo to use them as a key in store.
  dataIdFromObject: function dataIdFromObject(object) {
    return object.id || null;
  },
  // Given that we request node per global id which is a store key
  // we can tell Apollo to try fetch node from store by id first.
  // e.g. GetByIdQuery can read from store after SearchByBrandQuery was run
  cacheRedirects: {
    Query: {
      node: function node(_, _ref, _ref2) {
        var id = _ref.id;
        var getCacheKey = _ref2.getCacheKey;
        return getCacheKey({
          id: id
        });
      }
    }
  }
});
var stateLink = Object(__WEBPACK_IMPORTED_MODULE_4_apollo_link_state__["a" /* withClientState */])({
  cache: cache,
  resolvers: __WEBPACK_IMPORTED_MODULE_8__resolvers__["a" /* default */],
  defaults: __WEBPACK_IMPORTED_MODULE_9__state_defaults__["a" /* default */]
});
var authLink = new __WEBPACK_IMPORTED_MODULE_1_apollo_link__["a" /* ApolloLink */](function (operation, forward) {
  operation.setContext({
    headers: {
      "X-Request-Id": __WEBPACK_IMPORTED_MODULE_7_uuid___default.a.v4(),
      "X-CSRF-Token": Object(__WEBPACK_IMPORTED_MODULE_5__zendesk_knowledge_context__["getCSRFToken"])()
    }
  });
  return forward(operation);
});
var errorLink = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_link_error__["a" /* onError */])(function (_ref3) {
  var graphQLErrors = _ref3.graphQLErrors,
      networkError = _ref3.networkError;

  if (graphQLErrors) {
    graphQLErrors.forEach(function (_ref4) {
      var message = _ref4.message,
          locations = _ref4.locations,
          path = _ref4.path,
          extensions = _ref4.extensions;

      if (extensions && extensions.code === "UNAUTHENTICATED") {
        __WEBPACK_IMPORTED_MODULE_6__zendesk_knowledge_utils_lib_redirectToSignIn___default()();
      }
    });
  }
});
/* harmony default export */ __webpack_exports__["b"] = (new __WEBPACK_IMPORTED_MODULE_0_apollo_client__["ApolloClient"]({
  link: __WEBPACK_IMPORTED_MODULE_1_apollo_link__["a" /* ApolloLink */].from([stateLink, authLink, errorLink, new __WEBPACK_IMPORTED_MODULE_2_apollo_link_http__["a" /* HttpLink */]({
    uri: "/guide/graphql",
    credentials: "include",
    headers: {
      "X-Client-Id": __WEBPACK_IMPORTED_MODULE_7_uuid___default.a.v4()
    }
  })]),
  cache: cache
}));

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initialEditState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);

var initialEditState = {
  ruleName: "",
  frequency: "TWO_WEEKS",
  filters: [],
  notificationRecipient: "AUTHOR"
};
var defaults = {
  initialEditState: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({
    __typename: "InitialState"
  }, initialEditState),
  dirtyState: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({
    __typename: "DirtyState"
  }, initialEditState),
  wizard: {
    __typename: "Wizard",
    currentStep: "frequency",
    showValidation: false
  },
  articleMatchesPage: 1,
  showLoadingOverlay: false,
  notifications: []
};
/* harmony default export */ __webpack_exports__["a"] = (defaults);

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__StaleLoader__ = __webpack_require__(295);











var loadingOverlayQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "loadingOverlayQuery"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "showLoadingOverlay"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }]
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 66,
    "source": {
      "body": "\n  query loadingOverlayQuery {\n    showLoadingOverlay @client\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var LoadingOverlay =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(LoadingOverlay, _Component);

  function LoadingOverlay() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, LoadingOverlay);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(LoadingOverlay).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(LoadingOverlay, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Query"], {
        query: loadingOverlayQuery
      }, void 0, function (_ref) {
        var showLoadingOverlay = _ref.data.showLoadingOverlay;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__StaleLoader__["a" /* default */], {
          loading: showLoadingOverlay
        }, void 0, children);
      });
    }
  }]);

  return LoadingOverlay;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(LoadingOverlay, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node
});



/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StaleLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LoaderPanel__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_css__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_css__);














var Stale =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Stale, _Component);

  function Stale() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Stale);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Stale).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Stale, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var loading = nextProps.loading;
      return !loading;
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return Stale;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Stale, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.node,
  loading: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool
});

var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__LoaderPanel__["a" /* default */], {});

var StaleLoader =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(StaleLoader, _PureComponent);

  function StaleLoader() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, StaleLoader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(StaleLoader)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this)), "captureTab", function (e) {
      if (e.keyCode) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(StaleLoader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          delay = _this$props.delay,
          loading = _this$props.loading,
          testId = _this$props.testId;

      if (loading && __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.count(children) === 0) {
        return _ref;
      }

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__WEBPACK_IMPORTED_MODULE_12__styles_css___default.a.container, className)
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(Stale, {
        loading: loading
      }, void 0, children), loading && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        tabIndex: 0,
        autoFocus: true,
        onKeyDown: this.captureTab,
        className: __WEBPACK_IMPORTED_MODULE_12__styles_css___default.a.loaderOverlay,
        style: {
          animationDelay: "".concat(delay, "ms")
        }
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__LoaderPanel__["a" /* default */], {
        delayMS: 0,
        testId: testId
      })));
    }
  }]);

  return StaleLoader;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(StaleLoader, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,
  delay: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number.isRequired,
  loading: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,
  testId: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(StaleLoader, "defaultProps", {
  delay: 600
});



/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return completeStepMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return completeStep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_getNextStep__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_validateStep__ = __webpack_require__(668);



var completeStepMutation = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "completeStep"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "completeStep"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }]
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 56,
    "source": {
      "body": "\n  mutation completeStep {\n    completeStep @client\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var completeStepQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "wizard"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "currentStep"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "dirtyState"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "ruleName"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 107,
    "source": {
      "body": "\n  query {\n    wizard @client {\n      currentStep\n    }\n\n    dirtyState @client {\n      ruleName\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var completeStep = function completeStep(_, args, _ref) {
  var cache = _ref.cache;
  var cachedData = cache.readQuery({
    query: completeStepQuery
  });
  var currentStep = cachedData.wizard.currentStep;
  var nextStep = Object(__WEBPACK_IMPORTED_MODULE_0__state_getNextStep__["a" /* default */])(currentStep);

  if (nextStep === "complete") {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_navigation__["f" /* showIndex */])({
      skipDirtyCheck: true
    });
  } else {
    var isValid = Object(__WEBPACK_IMPORTED_MODULE_2__state_validateStep__["a" /* default */])(currentStep, cachedData);

    if (isValid) {
      var data = {
        wizard: {
          __typename: "Wizard",
          currentStep: nextStep,
          showValidation: false
        },
        articleMatchesPage: 1
      };
      cache.writeData({
        data: data
      });
    } else {
      var _data = {
        wizard: {
          __typename: "Wizard",
          currentStep: currentStep,
          showValidation: true
        }
      };
      cache.writeData({
        data: _data
      });
    }
  }

  return null;
};

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_components_lib_ModalDialog__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_components_lib_ModalDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_components_lib_ModalDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__zendeskgarden_react_theming__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__zendeskgarden_react_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__zendeskgarden_react_theming__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__zendesk_client_i18n_tools__);







var elm = document.createElement("div");
document.body.appendChild(elm);
var history = __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory___default()({
  basename: "/knowledge/verification/",
  getUserConfirmation: function getUserConfirmation(message, callback) {
    var onComplete = function onComplete(choice) {
      callback(choice);
      Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["render"])(null, elm);
    };

    Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5__zendeskgarden_react_theming__["ThemeProvider"], {
      rtl: __WEBPACK_IMPORTED_MODULE_6__zendesk_client_i18n_tools___default.a.dir === "rtl"
    }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_components_lib_ModalDialog___default.a, {
      testId: "discardChangesModal",
      visible: true,
      body: message,
      onSubmit: function onSubmit() {
        return onComplete(true);
      },
      onCancel: function onCancel() {
        return onComplete(false);
      }
    })), elm);
  }
});
/* harmony default export */ __webpack_exports__["a"] = (history);

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gotoPreviousStepMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gotoPreviousStep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_getPreviousStep__ = __webpack_require__(302);

var gotoPreviousStepMutation = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "gotoPreviousStep"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "gotoPreviousStep"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }]
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 64,
    "source": {
      "body": "\n  mutation gotoPreviousStep {\n    gotoPreviousStep @client\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var completeStepQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "CompleteStepQuery"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "wizard"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "currentStep"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 78,
    "source": {
      "body": "\n  query CompleteStepQuery {\n    wizard @client {\n      currentStep\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var gotoPreviousStep = function gotoPreviousStep(_, args, _ref) {
  var cache = _ref.cache;

  var _cache$readQuery = cache.readQuery({
    query: completeStepQuery
  }),
      wizard = _cache$readQuery.wizard;

  var data = {
    wizard: {
      __typename: "Wizard",
      currentStep: Object(__WEBPACK_IMPORTED_MODULE_0__state_getPreviousStep__["a" /* default */])(wizard.currentStep)
    },
    articleMatchesPage: 1
  };
  cache.writeData({
    data: data
  });
  return null;
};

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__steps__ = __webpack_require__(139);

var previousSteps = __WEBPACK_IMPORTED_MODULE_0__steps__["a" /* default */].reduce(function (result, step, index) {
  var previousStep = __WEBPACK_IMPORTED_MODULE_0__steps__["a" /* default */][index - 1];

  if (__WEBPACK_IMPORTED_MODULE_0__steps__["a" /* default */]) {
    result[step] = previousStep;
  }

  return result;
}, {});

var getPreviousStep = function getPreviousStep(currentStep) {
  return previousSteps[currentStep];
};

/* harmony default export */ __webpack_exports__["a"] = (getPreviousStep);

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FrequencyStep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_select__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_select__);











var frequencies = ["TWO_WEEKS", "ONE_MONTH", "THREE_MONTHS", "SIX_MONTHS", "ONE_YEAR"];

var FrequencyStep =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(FrequencyStep, _PureComponent);

  function FrequencyStep() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, FrequencyStep);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(FrequencyStep).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(FrequencyStep, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          selectedKey = _this$props.selectedKey;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_select__["SelectField"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_select__["Label"], {}, void 0, __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.frequency.label")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_select__["Hint"], {}, void 0, __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.frequency.hint")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_select__["Select"], {
        "data-test-id": "frequency-select",
        selectedKey: selectedKey,
        onChange: onChange,
        options: frequencies.map(function (frequency) {
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_select__["Item"], {}, frequency, __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.frequency.".concat(frequency)));
        })
      }, void 0, __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.frequency.".concat(selectedKey))));
    }
  }]);

  return FrequencyStep;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(FrequencyStep, "propTypes", {
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  selectedKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(frequencies).isRequired
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(FrequencyStep, "defaultProps", {
  selectedKey: frequencies[0]
});



/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__menuStructure__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_selection__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_selection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_selection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendeskgarden_react_menus__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendeskgarden_react_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__zendeskgarden_react_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mutations_addFilterMutation__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__keyToFilter__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_select__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_css__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_css__);






















var setupMenu = function setupMenu(_ref, parent) {
  var name = _ref.name,
      modal = _ref.modal,
      custom = _ref.custom,
      subMenus = _ref.subMenus,
      label = _ref.label;
  var kinds = [modal, custom, subMenus && subMenus.length].filter(Boolean).length;

  if (kinds > 1) {
    throw new Error("A menu item can only be either have a modal, a custom menu or a sub-menu");
  }

  var menu = {
    parent: parent,
    modal: modal,
    name: name,
    custom: custom,
    label: label || "knowledge-verification.filters.".concat(name)
  };
  menu.subMenus = (subMenus || []).map(function (subMenus) {
    return setupMenu(subMenus, menu);
  });
  return menu;
};

var rootMenu = setupMenu(__WEBPACK_IMPORTED_MODULE_14__menuStructure__["a" /* default */]);

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__zendeskgarden_react_menus__["Separator"], {});

var FilterMenu =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(FilterMenu, _Component);

  function FilterMenu() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, FilterMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(FilterMenu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      focusedKey: undefined,
      isOpen: false,
      menu: rootMenu,
      searchValue: ""
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getMenuContent", function (_ref2) {
      var getItemProps = _ref2.getItemProps,
          getNextItemProps = _ref2.getNextItemProps,
          getPreviousItemProps = _ref2.getPreviousItemProps,
          focusedKey = _ref2.focusedKey;
      var menu = _this.state.menu;

      if (menu.custom) {
        return menu.custom({
          getItemProps: getItemProps,
          getNextItemProps: getNextItemProps,
          getPreviousItemProps: getPreviousItemProps,
          focusedKey: focusedKey
        });
      }

      if (menu.subMenus.length === 0) {
        throw new Error("No subMenus was specified for ".concat(menu.name));
      }

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Fragment, {}, void 0, menu.parent && __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__zendeskgarden_react_menus__["PreviousItem"], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({}, getPreviousItemProps({
        key: menu.parent.name,
        focused: focusedKey === menu.parent.name
      }), {
        "data-test-id": "filter-menu-back"
      }), __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-verification.back")), menu.parent && _ref3, menu.subMenus.map(function (_ref4) {
        var name = _ref4.name,
            label = _ref4.label,
            subMenus = _ref4.subMenus,
            custom = _ref4.custom;
        return subMenus.length > 0 || custom ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__zendeskgarden_react_menus__["NextItem"], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({}, getNextItemProps({
          key: name,
          focused: focusedKey === name
        }), {
          "data-test-id": "filter-menu-".concat(name)
        }), __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()(label)) : __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__zendeskgarden_react_menus__["Item"], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({}, getItemProps({
          key: name,
          focused: focusedKey === name
        }), {
          "data-test-id": "filter-menu-".concat(name)
        }), __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()(label));
      }));
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "closeModal", function () {
      _this.setState({
        modal: null
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(FilterMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          focusedKey = _this$state.focusedKey,
          isOpen = _this$state.isOpen,
          modal = _this$state.modal;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Fragment, {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_select__["SelectGroup"], {
        className: __WEBPACK_IMPORTED_MODULE_20__styles_css___default.a.filterMenu
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_select__["Label"], {}, void 0, __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-verification.filterMenuLabel")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_select__["Hint"], {}, void 0, __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-verification.filterMenuHint")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["Mutation"], {
        mutation: __WEBPACK_IMPORTED_MODULE_17__mutations_addFilterMutation__["b" /* addFilterMutation */]
      }, void 0, function (mutate) {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__zendeskgarden_react_menus__["MenuContainer"], {
          isOpen: isOpen,
          placement: "bottom-start",
          focusedKey: focusedKey,
          onStateChange: function onStateChange(newState) {
            if (newState.isOpen === false) {
              // Menu is closing, we should reset the search input
              _this2.setState(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, newState, {
                searchValue: "",
                menu: rootMenu
              }));
            } else {
              _this2.setState(newState);
            }
          },
          onChange: function onChange(selectedKey) {
            var menu = _this2.state.menu;
            var subMenu = menu.subMenus.find(function (_ref5) {
              var name = _ref5.name;
              return name === selectedKey;
            });

            if (subMenu && subMenu.modal) {
              _this2.setState({
                modal: subMenu.modal(_this2.closeModal)
              });
            } else if (subMenu && (subMenu.subMenus.length > 0 || subMenu.custom)) {
              _this2.setState({
                menu: subMenu
              });
            } else if (menu.parent && menu.parent.name === selectedKey) {
              _this2.setState({
                menu: menu.parent
              });
            } else {
              mutate({
                variables: Object(__WEBPACK_IMPORTED_MODULE_18__keyToFilter__["a" /* default */])(selectedKey)
              });
            }
          },
          trigger: function trigger(_ref6) {
            var getTriggerProps = _ref6.getTriggerProps,
                triggerRef = _ref6.triggerRef,
                isOpen = _ref6.isOpen;
            return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_select__["SelectView"], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({}, getTriggerProps({
              open: isOpen,
              focused: isOpen,
              inputRef: function inputRef(ref) {
                _this2.triggerRef = ref;
                triggerRef(ref);
              }
            }), {
              "data-test-id": "filter-menu-trigger",
              style: {
                width: "300px"
              }
            }), __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-verification.filterMenu"));
          }
        }, void 0, function (_ref7) {
          var getMenuProps = _ref7.getMenuProps,
              menuRef = _ref7.menuRef,
              placement = _ref7.placement,
              getItemProps = _ref7.getItemProps,
              getNextItemProps = _ref7.getNextItemProps,
              getPreviousItemProps = _ref7.getPreviousItemProps,
              focusedKey = _ref7.focusedKey;
          return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__zendeskgarden_react_menus__["MenuView"], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({}, getMenuProps({
            placement: placement,
            animate: true,
            className: __WEBPACK_IMPORTED_MODULE_20__styles_css___default.a.menu,
            menuRef: menuRef,
            onKeyDown: function onKeyDown(event) {
              // We don't want the space key to trigger a selection
              // since there is a child input
              if (event.keyCode === __WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_selection__["KEY_CODES"].SPACE) {
                event.defaultPrevented = true;
              }
            }
          }), {
            "data-test-id": "filter-menu-popup"
          }), _this2.getMenuContent({
            getItemProps: getItemProps,
            getNextItemProps: getNextItemProps,
            getPreviousItemProps: getPreviousItemProps,
            focusedKey: focusedKey,
            menuRef: menuRef
          }));
        });
      })), modal && modal);
    }
  }]);

  return FilterMenu;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(FilterMenu, "propTypes", {
  subMenus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.node
});



/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var nextId = 0;

var createFilter = function createFilter(_ref) {
  var type = _ref.type,
      value = _ref.value;
  return {
    __typename: "Filter",
    id: nextId++,
    type: type,
    value: value
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFilter);

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var idFilters = ["brand", "author", "label", "permissionGroup", "userSegment", "section", "category"];
/* harmony default export */ __webpack_exports__["a"] = (idFilters);

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeFilterMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return removeFilter; });
var removeFilterMutation = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "removeFilter"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Number"
          }
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "removeFilter"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "id"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }
        }],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }]
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 79,
    "source": {
      "body": "\n  mutation removeFilter($id: Number!) {\n    removeFilter(id: $id) @client\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var dirtyStateQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "dirtyState"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "filters"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "type"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "value"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 108,
    "source": {
      "body": "\n  query {\n    dirtyState @client {\n      filters {\n        id\n        type\n        value\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var removeFilter = function removeFilter(_, _ref, _ref2) {
  var id = _ref.id;
  var cache = _ref2.cache;

  var _cache$readQuery = cache.readQuery({
    query: dirtyStateQuery
  }),
      dirtyState = _cache$readQuery.dirtyState;

  var data = {
    dirtyState: {
      __typename: "DirtyState",
      filters: dirtyState.filters.filter(function (filter) {
        return filter.id !== id;
      })
    },
    articleMatchesPage: 1
  };
  cache.writeData({
    data: data
  });
  return null;
};

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationsRecipientField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_select__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_select__);












var recipients = ["AUTHOR"];

var NotificationsRecipientField =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(NotificationsRecipientField, _PureComponent);

  function NotificationsRecipientField() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, NotificationsRecipientField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(NotificationsRecipientField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onChange", function (e) {
      var onChange = _this.props.onChange;
      onChange && onChange(e.target.value);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(NotificationsRecipientField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          value = _this$props.value;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_select__["SelectField"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_select__["Label"], {}, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.notifications.label")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_select__["Hint"], {}, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.notifications.recipient.hint")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_select__["Select"], {
        selectedKey: value,
        onChange: onChange,
        options: recipients.map(function (recipient) {
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_select__["Item"], {}, recipient, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.notifications.recipient.".concat(recipient)));
        })
      }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.notifications.recipient.".concat(value))));
    }
  }]);

  return NotificationsRecipientField;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(NotificationsRecipientField, "propTypes", {
  value: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(recipients).isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
});



/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArticleMatches; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_pagination__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_Gap__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_Gap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_Gap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Author__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mutations_updateArticleMatchesPageMutation__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_pageToCursor__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NoResults__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SearchFailure__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_prepareFilters__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_tables__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_css__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_css__);



















var dirtyStateQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "articleMatchesPage"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }]
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "dirtyState"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "filters"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "type"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "value"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 139,
    "source": {
      "body": "\n  query {\n    articleMatchesPage @client\n    dirtyState @client {\n      filters {\n        id\n        type\n        value\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var PAGE_SIZE = 15;
var articleQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "ArticleMatches"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "first"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "Int"
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "after"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "String"
        }
      }
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "filter"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "ArticlesQueryFilterInput"
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "articles"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "first"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "first"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "after"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "after"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "filter"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "filter"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "edges"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "node"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "author"
                    },
                    "arguments": [],
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "email"
                        },
                        "arguments": [],
                        "directives": []
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "name"
                        },
                        "arguments": [],
                        "directives": []
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "avatar"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "sourceTranslation"
                    },
                    "arguments": [],
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "locale"
                        },
                        "arguments": [],
                        "directives": []
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "title"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "updated"
                    },
                    "arguments": [],
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "datetime"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }]
                }
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "total"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 465,
    "source": {
      "body": "\n  query ArticleMatches(\n    $first: Int\n    $after: String\n    $filter: ArticlesQueryFilterInput\n  ) {\n    articles(first: $first, after: $after, filter: $filter) {\n      edges {\n        node {\n          id\n          author {\n            email\n            name\n            avatar\n          }\n          sourceTranslation {\n            locale\n            title\n          }\n          updated {\n            datetime\n          }\n        }\n      }\n      total\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__SearchFailure__["a" /* default */], {});

var _ref4 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__NoResults__["a" /* default */], {});

var _ref6 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_Gap___default.a.Large, {
  vertical: true
});

var ArticleMatches =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ArticleMatches, _PureComponent);

  function ArticleMatches() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ArticleMatches);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ArticleMatches).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ArticleMatches, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_18__styles_css___default.a.container
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_18__styles_css___default.a.table
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["Query"], {
        query: dirtyStateQuery
      }, void 0, function (_ref) {
        var _ref$data = _ref.data,
            filters = _ref$data.dirtyState.filters,
            articleMatchesPage = _ref$data.articleMatchesPage;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["Query"], {
          query: articleQuery,
          variables: {
            first: PAGE_SIZE,
            after: Object(__WEBPACK_IMPORTED_MODULE_13__utils_pageToCursor__["a" /* default */])(articleMatchesPage, PAGE_SIZE),
            filter: Object(__WEBPACK_IMPORTED_MODULE_16__utils_prepareFilters__["a" /* default */])(filters)
          }
        }, void 0, function (_ref2) {
          var loading = _ref2.loading,
              error = _ref2.error,
              data = _ref2.data;
          if (error) return _ref3;
          var _data$articles = data.articles,
              articles = _data$articles === void 0 ? {
            edges: [],
            total: 0
          } : _data$articles;

          if (!loading && articles.edges.length === 0) {
            return _ref4;
          }

          var totalPages = Math.ceil(articles.total / PAGE_SIZE); // TODO show loading page

          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment, {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("h2", {
            className: __WEBPACK_IMPORTED_MODULE_18__styles_css___default.a.title
          }, void 0, __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools___default()("knowledge-verification.totalAffected", {
            count: articles.total
          })), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_tables__["Table"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_tables__["Head"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_tables__["HeaderRow"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_tables__["HeaderCell"], {
            width: "60%"
          }, void 0, __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools___default()("knowledge-verification.table.articleName")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_tables__["HeaderCell"], {
            width: "20%"
          }, void 0, __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools___default()("knowledge-verification.table.lastEdited")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_tables__["HeaderCell"], {
            width: "20%"
          }, void 0, __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools___default()("knowledge-verification.table.author")))), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_tables__["Body"], {}, void 0, articles.edges.map(function (_ref5) {
            var node = _ref5.node;
            return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_tables__["Row"], {}, node.id, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_tables__["Cell"], {
              width: "60%",
              className: __WEBPACK_IMPORTED_MODULE_18__styles_css___default.a.cell
            }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("span", {
              className: __WEBPACK_IMPORTED_MODULE_18__styles_css___default.a.ellipsis
            }, void 0, node.sourceTranslation.title)), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_tables__["Cell"], {
              width: "15%",
              className: __WEBPACK_IMPORTED_MODULE_18__styles_css___default.a.cell
            }, void 0, __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools___default.a.relativeFormat().format(new Date(node.updated.datetime))), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_tables__["Cell"], {
              width: "25%",
              className: __WEBPACK_IMPORTED_MODULE_18__styles_css___default.a.cell
            }, void 0, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Author__["a" /* default */], node.author)));
          })), totalPages > 1 && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment, {}, void 0, _ref6, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["Mutation"], {
            mutation: __WEBPACK_IMPORTED_MODULE_12__mutations_updateArticleMatchesPageMutation__["b" /* updateArticleMatchesPageMutation */]
          }, void 0, function (mutate) {
            return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_pagination__["Pagination"], {
              className: __WEBPACK_IMPORTED_MODULE_18__styles_css___default.a.pagination,
              totalPages: totalPages,
              currentPage: articleMatchesPage,
              onChange: function onChange(page) {
                return mutate({
                  variables: {
                    page: page
                  }
                });
              }
            });
          }))));
        });
      })));
    }
  }]);

  return ArticleMatches;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);



/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateArticleMatchesPageMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateArticleMatchesPage; });
var updateArticleMatchesPageMutation = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "name": {
      "kind": "Name",
      "value": "updateArticleMatchesPage"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "page"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Number"
          }
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "updateArticleMatchesPage"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "page"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "page"
            }
          }
        }],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }]
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 109,
    "source": {
      "body": "\n  mutation updateArticleMatchesPage($page: Number!) {\n    updateArticleMatchesPage(page: $page) @client\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var updateArticleMatchesPage = function updateArticleMatchesPage(_, _ref, _ref2) {
  var page = _ref.page;
  var cache = _ref2.cache;
  cache.writeData({
    data: {
      articleMatchesPage: page
    }
  });
  return null;
};

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateVerificationRuleMutation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mutations_verificationRuleMutations__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_buttons__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_buttons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_buttons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_components_lib_Notifications_Connected__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_components_lib_Notifications_Connected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_components_lib_Notifications_Connected__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_prepareFilters__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MutationWithOverlay__ = __webpack_require__(220);

















var dirtyStateQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "dirtyState"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "ruleName"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "frequency"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "filters"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "type"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "value"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "notificationRecipient"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 156,
    "source": {
      "body": "\n  query {\n    dirtyState @client {\n      ruleName\n      frequency\n      filters {\n        type\n        value\n      }\n      notificationRecipient\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var CreateVerificationRuleMutation =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(CreateVerificationRuleMutation, _PureComponent);

  function CreateVerificationRuleMutation() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, CreateVerificationRuleMutation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(CreateVerificationRuleMutation)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onCreated", function (_ref) {
      var success = _ref.createVerificationRule.success;

      if (success) {
        Object(__WEBPACK_IMPORTED_MODULE_13__utils_navigation__["f" /* showIndex */])({
          skipDirtyCheck: true
        });
        __WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_components_lib_Notifications_Connected__["notifications"].showSuccess({
          title: __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.notification.verificationRuleCreate.title"),
          message: __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.notification.verificationRuleCreate.message")
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_components_lib_Notifications_Connected__["notifications"].showError({
          message: __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.notification.verificationRuleCreate.failed")
        });
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(CreateVerificationRuleMutation, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["Query"], {
        query: dirtyStateQuery
      }, void 0, function (_ref2) {
        var dirtyState = _ref2.data.dirtyState;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__MutationWithOverlay__["a" /* default */], {
          mutation: __WEBPACK_IMPORTED_MODULE_10__mutations_verificationRuleMutations__["a" /* createVerificationRuleMutation */],
          refetchQueries: ["verificationRules"],
          variables: {
            name: dirtyState.ruleName,
            filter: Object(__WEBPACK_IMPORTED_MODULE_15__utils_prepareFilters__["a" /* default */])(dirtyState.filters),
            frequency: dirtyState.frequency,
            notification: {
              recipient: dirtyState.notificationRecipient
            }
          },
          awaitRefetchQueries: true,
          onCompleted: _this2.onCreated
        }, void 0, function (mutate) {
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_buttons__["Button"], {
            size: "small",
            primary: true,
            onClick: mutate
          }, void 0, __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.create"));
        });
      });
    }
  }]);

  return CreateVerificationRuleMutation;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);



/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RULE_LIMIT; });
var RULE_LIMIT = 5;

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_resilient__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_resilient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_resilient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_components_lib_FatalErrorScreen__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_components_lib_FatalErrorScreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_components_lib_FatalErrorScreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_notifyError__ = __webpack_require__(813);







var reportError = function reportError(error) {
  return Object(__WEBPACK_IMPORTED_MODULE_5__utils_notifyError__["a" /* default */])("ErrorBoundary", error);
};

var ErrorBoundary = function ErrorBoundary(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_3_react_resilient___default.a, {
    FallbackComponent: __WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_components_lib_FatalErrorScreen___default.a,
    onError: reportError
  }, void 0, children);
};

ErrorBoundary.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(384);
module.exports = __webpack_require__(385);


/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_polyfill__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__zendesk_knowledge_utils_lib_PageNavigator_getQuery__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__zendesk_knowledge_utils_lib_PageNavigator_getQuery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__zendesk_knowledge_utils_lib_PageNavigator_getQuery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_analytics__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zendesk_knowledge_connect__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zendesk_knowledge_connect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__zendesk_knowledge_connect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_App__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_utils_lib_PageNavigator_navigate__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_utils_lib_PageNavigator_navigate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_utils_lib_PageNavigator_navigate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_history__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_isDirty__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_clearState__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_canAccessVerification__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_context__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendeskgarden_css_bedrock_dist_index_css__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendeskgarden_css_bedrock_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_css_bedrock_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendeskgarden_react_avatars_dist_styles_css__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendeskgarden_react_avatars_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__zendeskgarden_react_avatars_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_buttons_dist_styles_css__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_buttons_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_buttons_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__zendeskgarden_react_menus_dist_styles_css__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__zendeskgarden_react_menus_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__zendeskgarden_react_menus_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__zendeskgarden_react_modals_dist_styles_css__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__zendeskgarden_react_modals_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__zendeskgarden_react_modals_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__zendeskgarden_react_pagination_dist_styles_css__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__zendeskgarden_react_pagination_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__zendeskgarden_react_pagination_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__zendeskgarden_react_radios_dist_styles_css__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__zendeskgarden_react_radios_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__zendeskgarden_react_radios_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__zendeskgarden_react_select_dist_styles_css__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__zendeskgarden_react_select_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__zendeskgarden_react_select_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__zendeskgarden_react_tables_dist_styles_css__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__zendeskgarden_react_tables_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__zendeskgarden_react_tables_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__zendeskgarden_react_tags_dist_styles_css__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__zendeskgarden_react_tags_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__zendeskgarden_react_tags_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__zendeskgarden_react_textfields_dist_styles_css__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__zendeskgarden_react_textfields_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__zendeskgarden_react_textfields_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_global_css__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__styles_global_css__);





























var query = __WEBPACK_IMPORTED_MODULE_5__zendesk_knowledge_utils_lib_PageNavigator_getQuery___default()();

var renderApp = function renderApp(location) {
  var route = Object(__WEBPACK_IMPORTED_MODULE_14__utils_navigation__["b" /* getRoute */])();

  if (route === "index" || route === "new") {
    Object(__WEBPACK_IMPORTED_MODULE_13__utils_clearState__["a" /* default */])();
  }

  Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__components_App__["a" /* default */], {
    route: route,
    params: Object(__WEBPACK_IMPORTED_MODULE_14__utils_navigation__["a" /* getParams */])()
  }), document.getElementById("container"));
}; // Make sure a brand with a help center is selected.
// If brand_id in the query is not valid or is not set
// pick the agent brand or a first suitable brand


Object(__WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_context__["loadContext"])({
  brandId: query.brand_id
}).then(function (context) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_15__utils_canAccessVerification__["a" /* default */])(context)) {
    return __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_utils_lib_PageNavigator_navigate___default()("/hc/admin/general_settings");
  }

  var hasBrandId = "brand_id" in query;

  if (!hasBrandId) {
    Object(__WEBPACK_IMPORTED_MODULE_14__utils_navigation__["c" /* setBrandId */])();
  }

  __WEBPACK_IMPORTED_MODULE_6__zendesk_client_i18n_tools___default.a.load(context.token.user.locale, function () {
    document.title = __WEBPACK_IMPORTED_MODULE_6__zendesk_client_i18n_tools___default()("knowledge-verification.name");
    renderApp(__WEBPACK_IMPORTED_MODULE_11__utils_history__["a" /* default */].location);
    __WEBPACK_IMPORTED_MODULE_11__utils_history__["a" /* default */].listen(renderApp);

    window.onbeforeunload = function (evt) {
      if (Object(__WEBPACK_IMPORTED_MODULE_12__utils_isDirty__["a" /* default */])()) {
        return __WEBPACK_IMPORTED_MODULE_6__zendesk_client_i18n_tools___default()("knowledge-verification.discardConfirmation");
      }
    };

    __WEBPACK_IMPORTED_MODULE_11__utils_history__["a" /* default */].block(function (location, action) {
      if (location.state && location.state.skipDirtyCheck) return true;
      var route = Object(__WEBPACK_IMPORTED_MODULE_14__utils_navigation__["b" /* getRoute */])();

      if (["new", "edit", "duplicate"].includes(route) && Object(__WEBPACK_IMPORTED_MODULE_12__utils_isDirty__["a" /* default */])()) {
        return __WEBPACK_IMPORTED_MODULE_6__zendesk_client_i18n_tools___default()("knowledge-verification.discardConfirmation");
      }
    });
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_analytics___default.a.setup();
      __WEBPACK_IMPORTED_MODULE_8__zendesk_knowledge_connect___default.a.setup();
    }, 1000);
  });
});

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return showNewRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setBrandId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return showEditRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return showDuplicateRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__history__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_context__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_utils_lib_PageNavigator_destructurePath__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_utils_lib_PageNavigator_destructurePath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_utils_lib_PageNavigator_destructurePath__);



var showNewRoute = function showNewRoute() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  __WEBPACK_IMPORTED_MODULE_0__history__["a" /* default */].push("/new?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_context__["getCurrentBrandId"])()), state);
};
var setBrandId = function setBrandId() {
  __WEBPACK_IMPORTED_MODULE_0__history__["a" /* default */].replace("".concat(__WEBPACK_IMPORTED_MODULE_0__history__["a" /* default */].location.pathname, "?brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_context__["getCurrentBrandId"])()));
};
var showIndex = function showIndex() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  __WEBPACK_IMPORTED_MODULE_0__history__["a" /* default */].push("/?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_context__["getCurrentBrandId"])()), state);
};
var showEditRoute = function showEditRoute(ruleId) {
  __WEBPACK_IMPORTED_MODULE_0__history__["a" /* default */].push("/edit/".concat(ruleId, "?brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_context__["getCurrentBrandId"])()));
};
var showDuplicateRoute = function showDuplicateRoute(ruleId) {
  __WEBPACK_IMPORTED_MODULE_0__history__["a" /* default */].push("/duplicate/".concat(ruleId, "?brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_context__["getCurrentBrandId"])()));
};
var getRoute = function getRoute() {
  var _destructurePath = __WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_utils_lib_PageNavigator_destructurePath___default()("/:route", __WEBPACK_IMPORTED_MODULE_0__history__["a" /* default */].location.pathname),
      _destructurePath$rout = _destructurePath.route,
      route = _destructurePath$rout === void 0 ? "index" : _destructurePath$rout;

  return route;
};
var getParams = function getParams() {
  var route = getRoute();

  switch (route) {
    case "edit":
      var _destructurePath2 = __WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_utils_lib_PageNavigator_destructurePath___default()("/edit/:id", __WEBPACK_IMPORTED_MODULE_0__history__["a" /* default */].location.pathname),
          id = _destructurePath2.id;

      return {
        id: id
      };

    case "duplicate":
      var params = __WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_utils_lib_PageNavigator_destructurePath___default()("/duplicate/:id", __WEBPACK_IMPORTED_MODULE_0__history__["a" /* default */].location.pathname);
      return {
        id: params.id,
        isDuplicate: true
      };

    default:
      return {};
  }
};

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Filter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_loaders__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_loaders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_loaders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_tags__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_tags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_css__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_css__);














var Filter =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Filter, _PureComponent);

  function Filter() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Filter);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Filter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Filter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          loading = _this$props.loading,
          onClick = _this$props.onClick,
          type = _this$props.type,
          value = _this$props.value;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_tags__["Tag"], {
        size: "large",
        "data-test-id": "filter"
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("strong", {
        className: __WEBPACK_IMPORTED_MODULE_12__styles_css___default.a.label
      }, void 0, __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.filters.".concat(type)), ":"), "\xA0", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("span", {
        className: __WEBPACK_IMPORTED_MODULE_12__styles_css___default.a.value
      }, void 0, loading ? __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_loaders__["Dots"], {
        delayMS: 0,
        className: __WEBPACK_IMPORTED_MODULE_12__styles_css___default.a.loader
      }) : value), onClick && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_tags__["Close"], {
        onClick: onClick
      }));
    }
  }]);

  return Filter;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Filter, "propTypes", {
  loading: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
});



/***/ }),

/***/ 576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export App */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_theming__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_theming__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NewRoute__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__IndexRoute__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EditRoute__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__apollo_client__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_components_lib_Notifications_Connected__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_components_lib_Notifications_Connected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_components_lib_Notifications_Connected__);


















var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__NewRoute__["a" /* default */], {});

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__IndexRoute__["a" /* default */], {});

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_components_lib_Notifications_Connected__["Notifications"], {});

var App =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(App, _Component);

  function App() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, App);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(App).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(App, [{
    key: "renderRoute",
    value: function renderRoute(route) {
      var params = this.props.params;

      switch (route) {
        case "new":
          return _ref;

        case "edit":
        case "duplicate":
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__EditRoute__["a" /* default */], {
            id: params.id,
            isDuplicate: params.isDuplicate
          });

        default:
          return _ref2;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var route = this.props.route;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_theming__["ThemeProvider"], {
        rtl: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default.a.dir === "rtl"
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["ApolloProvider"], {
        client: __WEBPACK_IMPORTED_MODULE_15__apollo_client__["b" /* default */]
      }, void 0, this.renderRoute(route), _ref3));
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(App, "propTypes", {
  route: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(["index", "new", "edit", "duplicate"]).isRequired,
  params: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object.isRequired
});

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),

/***/ 621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_knowledge_chrome_lib_Chrome__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_knowledge_chrome_lib_Chrome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__zendesk_knowledge_chrome_lib_Chrome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_buttons__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_buttons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_buttons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_context__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_components_lib_Gap__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_components_lib_Gap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_components_lib_Gap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_components_lib_Wizard__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_components_lib_Wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_components_lib_Wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__LoadingOverlay__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mutations_completeStepMutation__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mutations_gotoPreviousStepMutation__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__state_hasPreviousStep__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__state_isStepBefore__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__state_steps__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__FrequencyStep__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__SegmentStep__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__NotificationStep__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ReviewStep__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ArticleMatches__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__CreateVerificationRuleMutation__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__styles_css__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__styles_css__);






























var currentStepQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "CurrentStep"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "wizard"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "currentStep"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 72,
    "source": {
      "body": "\n  query CurrentStep {\n    wizard @client {\n      currentStep\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Separator, {});

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Separator, {});

var _ref4 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_23__FrequencyStep__["a" /* default */], {});

var _ref5 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_24__SegmentStep__["a" /* default */], {});

var _ref6 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_25__NotificationStep__["a" /* default */], {});

var _ref7 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_26__ReviewStep__["a" /* default */], {});

var _ref8 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_27__ArticleMatches__["a" /* default */], {});

var _ref9 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_components_lib_Gap___default.a, {});

var NewRoute =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(NewRoute, _Component);

  function NewRoute() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, NewRoute);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(NewRoute)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "showIndex", function (e) {
      e.preventDefault();
      Object(__WEBPACK_IMPORTED_MODULE_19__utils_navigation__["f" /* showIndex */])();
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(NewRoute, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendesk_knowledge_chrome_lib_Chrome___default.a, {
        brandId: Object(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_context__["getCurrentBrandId"])(),
        dir: __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default.a.dir,
        topNav: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs, {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, "settings", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("a", {
          href: "/hc/admin/general_settings"
        }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.settings"))), _ref, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, "verification", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("a", {
          href: "/knowledge/verification/",
          onClick: this.showIndex
        }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.articleVerifications"))), _ref2, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, "newRule", __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.newRule")))
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Query"], {
        query: currentStepQuery
      }, void 0, function (_ref3) {
        var wizard = _ref3.data.wizard;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__LoadingOverlay__["a" /* default */], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_29__styles_css___default.a.content
        }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_29__styles_css___default.a.step
        }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_29__styles_css___default.a.form
        }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("h1", {
          className: __WEBPACK_IMPORTED_MODULE_29__styles_css___default.a.title
        }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.createVerificationRule")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_29__styles_css___default.a.wizardContainer
        }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_components_lib_Wizard___default.a, {
          dir: __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default.a.dir
        }, void 0, __WEBPACK_IMPORTED_MODULE_22__state_steps__["a" /* default */].map(function (step) {
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_components_lib_Wizard___default.a.Step, {
            label: __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.step.".concat(step)),
            active: wizard.currentStep === step,
            completed: Object(__WEBPACK_IMPORTED_MODULE_21__state_isStepBefore__["a" /* default */])(step, wizard.currentStep)
          }, step);
        })), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_29__styles_css___default.a.wizardStep
        }, void 0, wizard.currentStep === "frequency" && _ref4, wizard.currentStep === "segment" && _ref5, wizard.currentStep === "notification" && _ref6, wizard.currentStep === "review" && _ref7))), ["segment", "review"].includes(wizard.currentStep) && _ref8), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_29__styles_css___default.a.buttons
        }, void 0, Object(__WEBPACK_IMPORTED_MODULE_20__state_hasPreviousStep__["a" /* default */])(wizard.currentStep) ? __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Mutation"], {
          mutation: __WEBPACK_IMPORTED_MODULE_18__mutations_gotoPreviousStepMutation__["b" /* gotoPreviousStepMutation */]
        }, void 0, function (mutate) {
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_buttons__["Button"], {
            size: "small",
            onClick: mutate
          }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.back"));
        }) : __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_buttons__["Button"], {
          size: "small",
          onClick: _this2.showIndex
        }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.cancel")), _ref9, wizard.currentStep === "review" ? __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_28__CreateVerificationRuleMutation__["a" /* default */], {}, void 0, function (mutate) {
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_buttons__["Button"], {
            size: "small",
            primary: true,
            onClick: mutate
          }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.create"));
        }) : __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Mutation"], {
          mutation: __WEBPACK_IMPORTED_MODULE_17__mutations_completeStepMutation__["b" /* completeStepMutation */]
        }, void 0, function (mutate) {
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_buttons__["Button"], {
            size: "small",
            primary: true,
            onClick: mutate
          }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.next"));
        }))));
      }));
    }
  }]);

  return NewRoute;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);



/***/ }),

/***/ 649:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loader":"_-src-components-LoaderPanel-styles---loader---2Onid"};

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_-src-components-StaleLoader-styles---container---3t9OJ","loaderOverlay":"_-src-components-StaleLoader-styles---loaderOverlay---1kj-E","fadein":"_-src-components-StaleLoader-styles---fadein---1UK-N"};

/***/ }),

/***/ 651:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__steps__ = __webpack_require__(139);

var nextSteps = __WEBPACK_IMPORTED_MODULE_0__steps__["a" /* default */].reduce(function (result, step, index) {
  result[step] = __WEBPACK_IMPORTED_MODULE_0__steps__["a" /* default */][index + 1] || "complete";
  return result;
}, {});

var getNextStep = function getNextStep(currentStep) {
  return nextSteps[currentStep];
};

/* harmony default export */ __webpack_exports__["a"] = (getNextStep);

/***/ }),

/***/ 668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validateFrequencyStep__ = __webpack_require__(669);


var validateStep = function validateStep(step, state) {
  switch (step) {
    case "frequency":
      return Object(__WEBPACK_IMPORTED_MODULE_0__validateFrequencyStep__["a" /* default */])(state.dirtyState);

    default:
      return true;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (validateStep);

/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validateRuleName__ = __webpack_require__(141);


var validateFrequencyStep = function validateFrequencyStep(_ref) {
  var ruleName = _ref.ruleName;
  return Object(__WEBPACK_IMPORTED_MODULE_0__validateRuleName__["a" /* default */])(ruleName);
};

/* harmony default export */ __webpack_exports__["a"] = (validateFrequencyStep);

/***/ }),

/***/ 670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPreviousStep__ = __webpack_require__(302);


var hasPreviousStep = function hasPreviousStep(currentStep) {
  return Boolean(Object(__WEBPACK_IMPORTED_MODULE_0__getPreviousStep__["a" /* default */])(currentStep));
};

/* harmony default export */ __webpack_exports__["a"] = (hasPreviousStep);

/***/ }),

/***/ 671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__steps__ = __webpack_require__(139);


var isStepBefore = function isStepBefore(firstStep, secondStep) {
  return __WEBPACK_IMPORTED_MODULE_0__steps__["a" /* default */].indexOf(firstStep) < __WEBPACK_IMPORTED_MODULE_0__steps__["a" /* default */].indexOf(secondStep);
};

/* harmony default export */ __webpack_exports__["a"] = (isStepBefore);

/***/ }),

/***/ 672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export frequencyStepQuery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_components_lib_Gap__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_components_lib_Gap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_components_lib_Gap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FrequencyField__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RuleNameField__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__state_validateRuleName__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mutations_updateDirtyStateMutation__ = __webpack_require__(143);













var frequencyStepQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "FrequencyStep"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "wizard"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "showValidation"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "dirtyState"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "ruleName"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "frequency"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 139,
    "source": {
      "body": "\n  query FrequencyStep {\n    wizard @client {\n      showValidation\n    }\n    dirtyState @client {\n      ruleName\n      frequency\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_components_lib_Gap___default.a.Huge, {
  vertical: true
});

var FrequencyStep =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(FrequencyStep, _PureComponent);

  function FrequencyStep() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, FrequencyStep);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(FrequencyStep).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(FrequencyStep, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"], {
        query: frequencyStepQuery
      }, void 0, function (_ref) {
        var _ref$data = _ref.data,
            dirtyState = _ref$data.dirtyState,
            wizard = _ref$data.wizard;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Mutation"], {
          mutation: __WEBPACK_IMPORTED_MODULE_12__mutations_updateDirtyStateMutation__["b" /* updateDirtyStateMutation */]
        }, void 0, function (mutate) {
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__RuleNameField__["a" /* default */], {
            value: dirtyState.ruleName,
            onChange: function onChange(event) {
              return mutate({
                variables: {
                  data: {
                    ruleName: event.target.value
                  }
                }
              });
            },
            showValidation: wizard.showValidation && !Object(__WEBPACK_IMPORTED_MODULE_10__state_validateRuleName__["a" /* default */])(dirtyState.ruleName)
          }), _ref2, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__FrequencyField__["a" /* default */], {
            selectedKey: dirtyState.frequency,
            onChange: function onChange(key) {
              return mutate({
                variables: {
                  data: {
                    frequency: key
                  }
                }
              });
            }
          }));
        });
      });
    }
  }]);

  return FrequencyStep;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (FrequencyStep);

/***/ }),

/***/ 679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RuleNameField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_textfields__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_textfields___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_textfields__);












var RuleNameField =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(RuleNameField, _PureComponent);

  function RuleNameField() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, RuleNameField);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(RuleNameField).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(RuleNameField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          showValidation = _this$props.showValidation,
          value = _this$props.value;
      var validation = showValidation ? "error" : "none";
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_textfields__["TextField"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_textfields__["Label"], {}, void 0, __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.ruleName")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_textfields__["Input"], {
        "data-test-id": "rule-name-input",
        onChange: onChange,
        placeholder: __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.ruleNamePlaceholder"),
        value: value,
        validation: validation
      }), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_textfields__["Message"], {
        "data-test-id": "rule-name-validation",
        validation: validation,
        style: {
          display: showValidation ? "inherit" : "none"
        }
      }, void 0, __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.ruleNameMissing")));
    }
  }]);

  return RuleNameField;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(RuleNameField, "propTypes", {
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  showValidation: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});



/***/ }),

/***/ 680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FilterMenu__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zendesk_knowledge_components_lib_Gap__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zendesk_knowledge_components_lib_Gap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__zendesk_knowledge_components_lib_Gap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FilterList__ = __webpack_require__(216);











var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment, {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__FilterMenu__["a" /* default */], {}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__zendesk_knowledge_components_lib_Gap___default.a.Large, {
  vertical: true
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__FilterList__["a" /* default */], {
  removable: true
}));

var SegmentStep =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SegmentStep, _Component);

  function SegmentStep() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, SegmentStep);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SegmentStep).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SegmentStep, [{
    key: "render",
    value: function render() {
      return _ref;
    }
  }]);

  return SegmentStep;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SegmentStep);

/***/ }),

/***/ 681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AuthorMenu__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BrandMenu__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LabelMenu__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PermissionGroupMenu__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserSegmentsMenu__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PlacementSelectorModal__ = __webpack_require__(698);









var relativeDates = ["ONE_DAY_AGO", "ONE_WEEK_AGO", "ONE_MONTH_AGO", "THREE_MONTHS_AGO", "SIX_MONTHS_AGO", "ONE_YEAR_AGO"];
var menuStructure = {
  name: "root",
  subMenus: [{
    name: "brand",
    custom: function custom(props) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BrandMenu__["a" /* default */], props);
    }
  }, {
    name: "author",
    custom: function custom(props) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AuthorMenu__["a" /* default */], props);
    }
  }, {
    name: "placement",
    label: "knowledge-verification.placement",
    modal: function modal(onClose) {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__PlacementSelectorModal__["a" /* default */], {
        onClose: onClose
      });
    }
  }, {
    name: "permissionGroup",
    custom: function custom(props) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PermissionGroupMenu__["a" /* default */], props);
    }
  }, {
    name: "userSegment",
    custom: function custom(props) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__UserSegmentsMenu__["a" /* default */], props);
    }
  }, {
    name: "origin",
    subMenus: [{
      name: "origin-KNOWLEDGE_CAPTURE"
    }]
  }, {
    name: "isOpenForComment",
    subMenus: [{
      name: "isOpenForComment-yes",
      label: "knowledge-verification.yes"
    }, {
      name: "isOpenForComment-no",
      label: "knowledge-verification.no"
    }]
  }, {
    name: "label",
    custom: function custom(props) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LabelMenu__["a" /* default */], props);
    }
  }, {
    name: "isPromoted",
    subMenus: [{
      name: "isPromoted-yes",
      label: "knowledge-verification.yes"
    }, {
      name: "isPromoted-no",
      label: "knowledge-verification.no"
    }]
  }].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(["created", "updated"].map(function (name) {
    return {
      name: name,
      subMenus: [{
        name: "".concat(name, "-less-than"),
        label: "knowledge-verification.filters.lessThan",
        subMenus: relativeDates.map(function (key) {
          return {
            name: "".concat(name, "-LESS_THAN_").concat(key),
            label: "knowledge-verification.".concat(key)
          };
        })
      }, {
        name: "".concat(name, "-more-than"),
        label: "knowledge-verification.filters.moreThan",
        subMenus: relativeDates.map(function (key) {
          return {
            name: "".concat(name, "-MORE_THAN_").concat(key),
            label: "knowledge-verification.".concat(key)
          };
        })
      }]
    };
  })))
};
/* harmony default export */ __webpack_exports__["a"] = (menuStructure);

/***/ }),

/***/ 684:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthorMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SearchMenu__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_css__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_css__);















var authorsQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "Authors"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "name"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "String"
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "authors"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "filter"
          },
          "value": {
            "kind": "ObjectValue",
            "fields": [{
              "kind": "ObjectField",
              "name": {
                "kind": "Name",
                "value": "role"
              },
              "value": {
                "kind": "ListValue",
                "values": [{
                  "kind": "EnumValue",
                  "value": "MANAGER"
                }, {
                  "kind": "EnumValue",
                  "value": "ADMIN"
                }, {
                  "kind": "EnumValue",
                  "value": "AGENT"
                }]
              }
            }]
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "query"
          },
          "value": {
            "kind": "ObjectValue",
            "fields": [{
              "kind": "ObjectField",
              "name": {
                "kind": "Name",
                "value": "name"
              },
              "value": {
                "kind": "Variable",
                "name": {
                  "kind": "Name",
                  "value": "name"
                }
              }
            }]
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "edges"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "node"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "name"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "email"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 216,
    "source": {
      "body": "\n  query Authors($name: String) {\n    authors(filter: { role: [MANAGER, ADMIN, AGENT] }, query: { name: $name }) {\n      edges {\n        node {\n          id\n          name\n          email\n        }\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */].SearchFailure, {});

var AuthorMenu =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(AuthorMenu, _Component);

  function AuthorMenu() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, AuthorMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(AuthorMenu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      searchText: ""
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onSearchTextChanged", function (searchText) {
      _this.setState({
        searchText: searchText
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(AuthorMenu, [{
    key: "render",
    value: function render() {
      var searchText = this.state.searchText;
      var _this$props = this.props,
          getItemProps = _this$props.getItemProps,
          focusedKey = _this$props.focusedKey;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */], {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */].Input, {
        onChange: this.onSearchTextChanged
      }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"], {
        query: authorsQuery,
        variables: {
          name: searchText
        }
      }, void 0, function (_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            data = _ref.data;
        if (error) return _ref2;
        var _data$authors = data.authors,
            authors = _data$authors === void 0 ? {
          edges: [],
          total: 0
        } : _data$authors;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */].Items, {}, void 0, authors.edges.map(function (_ref3) {
          var _ref3$node = _ref3.node,
              id = _ref3$node.id,
              name = _ref3$node.name,
              email = _ref3$node.email;
          return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__["MediaItem"], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, getItemProps({
            key: "author-".concat(id),
            focused: focusedKey === "author-".concat(id)
          }), {
            "data-test-id": "filter-menu-author-item-".concat(id)
          }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__["MediaBody"], {}, void 0, name, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__["ItemMeta"], {
            className: __WEBPACK_IMPORTED_MODULE_14__styles_css___default.a.authorEmail
          }, void 0, email)));
        }));
      }));
    }
  }]);

  return AuthorMenu;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(AuthorMenu, "propTypes", {
  getItemProps: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired,
  focusedKey: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string
});



/***/ }),

/***/ 692:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoResults; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_css__);










var NoResults =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(NoResults, _PureComponent);

  function NoResults() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, NoResults);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(NoResults).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(NoResults, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_8__styles_css___default.a.noResults,
        "data-test-id": "filter-menu-no-results"
      }, void 0, __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools___default()("knowledge-verification.noResults"));
    }
  }]);

  return NoResults;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);



/***/ }),

/***/ 693:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchFailure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_css__);










var SearchFailure =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SearchFailure, _PureComponent);

  function SearchFailure() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, SearchFailure);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SearchFailure).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SearchFailure, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_8__styles_css___default.a.searchFailure,
        "data-test-id": "filter-menu-search-failure"
      }, void 0, __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools___default()("knowledge-verification.searchFailure"));
    }
  }]);

  return SearchFailure;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);



/***/ }),

/***/ 694:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SearchMenu__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);














var brandsQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "Brands"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "name"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "String"
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "brands"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "query"
          },
          "value": {
            "kind": "ObjectValue",
            "fields": [{
              "kind": "ObjectField",
              "name": {
                "kind": "Name",
                "value": "name"
              },
              "value": {
                "kind": "Variable",
                "name": {
                  "kind": "Name",
                  "value": "name"
                }
              }
            }]
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "edges"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "node"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "name"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 155,
    "source": {
      "body": "\n  query Brands($name: String) {\n    brands(query: { name: $name }) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */].SearchFailure, {});

var LabelMenu =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(LabelMenu, _Component);

  function LabelMenu() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, LabelMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(LabelMenu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      searchText: ""
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onSearchTextChanged", function (searchText) {
      _this.setState({
        searchText: searchText
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(LabelMenu, [{
    key: "render",
    value: function render() {
      var searchText = this.state.searchText;
      var _this$props = this.props,
          getItemProps = _this$props.getItemProps,
          focusedKey = _this$props.focusedKey;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */], {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */].Input, {
        onChange: this.onSearchTextChanged
      }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"], {
        query: brandsQuery,
        variables: {
          name: searchText
        }
      }, void 0, function (_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            data = _ref.data;
        if (error) return _ref2;
        var _data$brands = data.brands,
            brands = _data$brands === void 0 ? {
          edges: [],
          total: 0
        } : _data$brands;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */].Items, {}, void 0, brands.edges.map(function (_ref3) {
          var _ref3$node = _ref3.node,
              id = _ref3$node.id,
              name = _ref3$node.name;
          return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__["Item"], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, getItemProps({
            key: "brand-".concat(id),
            focused: focusedKey === "brand-".concat(id)
          }), {
            "data-test-id": "filter-menu-brand-item-".concat(id)
          }), name);
        }));
      }));
    }
  }]);

  return LabelMenu;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(LabelMenu, "propTypes", {
  getItemProps: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired,
  focusedKey: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string
});



/***/ }),

/***/ 695:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SearchMenu__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);














var labelsQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "Labels"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "name"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "String"
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "labels"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "query"
          },
          "value": {
            "kind": "ObjectValue",
            "fields": [{
              "kind": "ObjectField",
              "name": {
                "kind": "Name",
                "value": "name"
              },
              "value": {
                "kind": "Variable",
                "name": {
                  "kind": "Name",
                  "value": "name"
                }
              }
            }]
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "edges"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "node"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "name"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 155,
    "source": {
      "body": "\n  query Labels($name: String) {\n    labels(query: { name: $name }) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */].SearchFailure, {});

var LabelMenu =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(LabelMenu, _Component);

  function LabelMenu() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, LabelMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(LabelMenu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      searchText: ""
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onSearchTextChanged", function (searchText) {
      _this.setState({
        searchText: searchText
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(LabelMenu, [{
    key: "render",
    value: function render() {
      var searchText = this.state.searchText;
      var _this$props = this.props,
          getItemProps = _this$props.getItemProps,
          focusedKey = _this$props.focusedKey;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */], {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */].Input, {
        onChange: this.onSearchTextChanged
      }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"], {
        query: labelsQuery,
        variables: {
          name: searchText
        }
      }, void 0, function (_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            data = _ref.data;
        if (error) return _ref2;
        var _data$labels = data.labels,
            labels = _data$labels === void 0 ? {
          edges: [],
          total: 0
        } : _data$labels;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */].Items, {}, void 0, labels.edges.map(function (_ref3) {
          var _ref3$node = _ref3.node,
              id = _ref3$node.id,
              name = _ref3$node.name;
          return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__["Item"], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, getItemProps({
            key: "label-".concat(id),
            focused: focusedKey === "label-".concat(id)
          }), {
            "data-test-id": "filter-menu-label-item-".concat(id)
          }), name);
        }));
      }));
    }
  }]);

  return LabelMenu;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(LabelMenu, "propTypes", {
  getItemProps: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired,
  focusedKey: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string
});



/***/ }),

/***/ 696:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PermissionGroupMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SearchMenu__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);













var permissionGroupsQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "PermissionGroups"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "permissionGroups"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "edges"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "node"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "name"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 136,
    "source": {
      "body": "\n  query PermissionGroups {\n    permissionGroups {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__SearchMenu__["a" /* default */].SearchFailure, {});

var PermissionGroupMenu =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(PermissionGroupMenu, _Component);

  function PermissionGroupMenu() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, PermissionGroupMenu);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(PermissionGroupMenu).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(PermissionGroupMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          getItemProps = _this$props.getItemProps,
          focusedKey = _this$props.focusedKey;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["Query"], {
        query: permissionGroupsQuery
      }, void 0, function (_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            data = _ref.data;
        if (error) return _ref2;
        var _data$permissionGroup = data.permissionGroups,
            permissionGroups = _data$permissionGroup === void 0 ? {
          edges: [],
          total: 0
        } : _data$permissionGroup;
        return permissionGroups.edges.map(function (_ref3) {
          var _ref3$node = _ref3.node,
              id = _ref3$node.id,
              name = _ref3$node.name;
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus__["Item"], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, getItemProps({
            key: "permissionGroup-".concat(id),
            focused: focusedKey === "permissionGroup-".concat(id)
          }), {
            "data-test-id": "filter-menu-permissionGroup-item-".concat(id)
          }), name);
        });
      });
    }
  }]);

  return PermissionGroupMenu;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(PermissionGroupMenu, "propTypes", {
  getItemProps: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,
  focusedKey: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string
});



/***/ }),

/***/ 697:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserSegmentsMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SearchMenu__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);














var userSegmentsQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "UserSegments"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "name"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "String"
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "userSegments"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "query"
          },
          "value": {
            "kind": "ObjectValue",
            "fields": [{
              "kind": "ObjectField",
              "name": {
                "kind": "Name",
                "value": "name"
              },
              "value": {
                "kind": "Variable",
                "name": {
                  "kind": "Name",
                  "value": "name"
                }
              }
            }]
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "edges"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "node"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "name"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 167,
    "source": {
      "body": "\n  query UserSegments($name: String) {\n    userSegments(query: { name: $name }) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__["Separator"], {});

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */].SearchFailure, {});

var UserSegmentsMenu =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(UserSegmentsMenu, _Component);

  function UserSegmentsMenu() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, UserSegmentsMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(UserSegmentsMenu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      searchText: ""
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onSearchTextChanged", function (searchText) {
      _this.setState({
        searchText: searchText
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(UserSegmentsMenu, [{
    key: "render",
    value: function render() {
      var searchText = this.state.searchText;
      var _this$props = this.props,
          getItemProps = _this$props.getItemProps,
          focusedKey = _this$props.focusedKey;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */], {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */].Input, {
        onChange: this.onSearchTextChanged
      }), _ref, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"], {
        query: userSegmentsQuery,
        variables: {
          name: searchText
        }
      }, void 0, function (_ref2) {
        var loading = _ref2.loading,
            error = _ref2.error,
            data = _ref2.data;
        if (error) return _ref3;
        var _data$userSegments = data.userSegments,
            userSegments = _data$userSegments === void 0 ? {
          edges: [],
          total: 0
        } : _data$userSegments;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__SearchMenu__["a" /* default */].Items, {}, void 0, userSegments.edges.map(function (_ref4) {
          var _ref4$node = _ref4.node,
              id = _ref4$node.id,
              name = _ref4$node.name;
          return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__["Item"], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, getItemProps({
            key: "userSegment-".concat(id),
            focused: focusedKey === "userSegment-".concat(id)
          }), {
            "data-test-id": "filter-menu-userSegment-item-".concat(id)
          }), name);
        }));
      }));
    }
  }]);

  return UserSegmentsMenu;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(UserSegmentsMenu, "propTypes", {
  getItemProps: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired,
  focusedKey: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string
});



/***/ }),

/***/ 698:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlacementFilterModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_PlacementSelector__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_PlacementSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_PlacementSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_components_lib_ModalDialog__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_components_lib_ModalDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_components_lib_ModalDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mutations_addFilterMutation__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_utils_lib_toGlobalId__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_utils_lib_toGlobalId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_utils_lib_toGlobalId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PlacementSelectorModal_css__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PlacementSelectorModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__PlacementSelectorModal_css__);


















var PlacementFilterModal =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(PlacementFilterModal, _Component);

  function PlacementFilterModal(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, PlacementFilterModal);

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(PlacementFilterModal).call(this, props));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onOptionClick", function (option) {
      _this.setState({
        selectedOption: option
      });
    });

    _this.state = {
      selectedOption: {}
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(PlacementFilterModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var onClose = this.props.onClose;
      var selectedOption = this.state.selectedOption;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Mutation"], {
        mutation: __WEBPACK_IMPORTED_MODULE_14__mutations_addFilterMutation__["b" /* addFilterMutation */]
      }, void 0, function (mutate) {
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_components_lib_ModalDialog___default.a, {
          id: "placementSelectorModal",
          title: __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default()("knowledge-verification.placement"),
          testId: "placementSelectorModal",
          body: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
            className: __WEBPACK_IMPORTED_MODULE_16__PlacementSelectorModal_css___default.a.body
          }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("p", {
            className: __WEBPACK_IMPORTED_MODULE_16__PlacementSelectorModal_css___default.a.description
          }, void 0, __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default()("knowledge-verification.selectCategoryOrSection")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_PlacementSelector___default.a, {
            onOptionSelect: _this2.onOptionClick
          })),
          onSubmit: function onSubmit() {
            onClose();
            mutate({
              variables: {
                type: selectedOption.type.toLowerCase(),
                value: __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_utils_lib_toGlobalId___default()(selectedOption.type, selectedOption.id)
              }
            });
          },
          onCancel: onClose,
          submitDisabled: !selectedOption.id,
          visible: true
        });
      });
    }
  }]);

  return PlacementFilterModal;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(PlacementFilterModal, "propTypes", {
  onClose: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func.isRequired
});



/***/ }),

/***/ 757:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"_-src-components-FilterMenu-PlacementSelectorModal---body---14EQ-","description":"_-src-components-FilterMenu-PlacementSelectorModal---description---2ARjf"};

/***/ }),

/***/ 758:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toArray__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_idFilters__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_yesNoFilters__ = __webpack_require__(147);




var keyToFilter = function keyToFilter(key) {
  var _key$split = key.split("-"),
      _key$split2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toArray___default()(_key$split),
      type = _key$split2[0],
      rest = _key$split2.slice(1);

  var value = rest.join("-");

  if (__WEBPACK_IMPORTED_MODULE_2__state_yesNoFilters__["a" /* default */].includes(type)) {
    return {
      type: type,
      value: value === "yes"
    };
  }

  if (__WEBPACK_IMPORTED_MODULE_1__state_idFilters__["a" /* default */].includes(type) || ["origin", "created", "updated"].includes(type)) {
    return {
      type: type,
      value: value
    };
  }

  throw new Error("Can't convert key into filter: ".concat(key));
};

/* harmony default export */ __webpack_exports__["a"] = (keyToFilter);

/***/ }),

/***/ 762:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Filter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AuthorFilter__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BrandFilter__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CategoryFilter__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FilterTag__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LabelFilter__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__OriginFilter__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PermissionGroupFilter__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__UserSegmentFilter__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SectionFilter__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__YesNoFilter__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__state_yesNoFilters__ = __webpack_require__(147);






















var Filter =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Filter, _Component);

  function Filter() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Filter);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Filter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Filter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          type = _this$props.type,
          value = _this$props.value;

      if (__WEBPACK_IMPORTED_MODULE_20__state_yesNoFilters__["a" /* default */].includes(type)) {
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_19__YesNoFilter__["a" /* default */], {
          onClick: onClick,
          type: type,
          value: value
        });
      }

      switch (type) {
        case "author":
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__AuthorFilter__["a" /* default */], {
            onClick: onClick,
            type: type,
            value: value
          });

        case "brand":
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__BrandFilter__["a" /* default */], {
            onClick: onClick,
            type: type,
            value: value
          });

        case "label":
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__LabelFilter__["a" /* default */], {
            onClick: onClick,
            type: type,
            value: value
          });

        case "origin":
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__OriginFilter__["a" /* default */], {
            onClick: onClick,
            type: type,
            value: value
          });

        case "category":
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__CategoryFilter__["a" /* default */], {
            onClick: onClick,
            type: type,
            value: value
          });

        case "section":
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_18__SectionFilter__["a" /* default */], {
            onClick: onClick,
            type: type,
            value: value
          });

        case "permissionGroup":
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__PermissionGroupFilter__["a" /* default */], {
            onClick: onClick,
            type: type,
            value: value
          });

        case "userSegment":
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__UserSegmentFilter__["a" /* default */], {
            onClick: onClick,
            type: type,
            value: value
          });

        case "updated":
        case "created":
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__FilterTag__["a" /* default */], {
            onClick: onClick,
            type: type,
            value: __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.".concat(value))
          });

        default:
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__FilterTag__["a" /* default */], {
            onClick: onClick,
            type: type,
            value: value
          });
      }
    }
  }]);

  return Filter;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Filter, "propTypes", {
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any
});



/***/ }),

/***/ 763:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthorFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FilterTag__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);











var authorQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "Author"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ID"
          }
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "node"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "id"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "User"
              }
            },
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "name"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 108,
    "source": {
      "body": "\n  query Author($id: ID!) {\n    node(id: $id) {\n      id\n      ... on User {\n        name\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var AuthorFilter =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AuthorFilter, _PureComponent);

  function AuthorFilter() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AuthorFilter);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(AuthorFilter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AuthorFilter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          type = _this$props.type,
          value = _this$props.value;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Query"], {
        query: authorQuery,
        variables: {
          id: value
        }
      }, void 0, function (_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            data = _ref.data;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__FilterTag__["a" /* default */], {
          type: type,
          loading: loading,
          onClick: onClick,
          value: data && data.node && data.node.name || value
        });
      });
    }
  }]);

  return AuthorFilter;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AuthorFilter, "propTypes", {
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired
});



/***/ }),

/***/ 765:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label":"_-src-components-Filter-FilterTag-styles---label---2qkfP","value":"_-src-components-Filter-FilterTag-styles---value---1bLxv","loader":"_-src-components-Filter-FilterTag-styles---loader---37mR2"};

/***/ }),

/***/ 766:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FilterTag__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);











var brandQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "Brand"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ID"
          }
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "node"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "id"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "Brand"
              }
            },
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "name"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 108,
    "source": {
      "body": "\n  query Brand($id: ID!) {\n    node(id: $id) {\n      id\n      ... on Brand {\n        name\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var LabelFilter =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(LabelFilter, _PureComponent);

  function LabelFilter() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, LabelFilter);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(LabelFilter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(LabelFilter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          type = _this$props.type,
          value = _this$props.value;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Query"], {
        query: brandQuery,
        variables: {
          id: value
        }
      }, void 0, function (_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            data = _ref.data;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__FilterTag__["a" /* default */], {
          type: type,
          loading: loading,
          onClick: onClick,
          value: data && data.node && data.node.name || value
        });
      });
    }
  }]);

  return LabelFilter;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(LabelFilter, "propTypes", {
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired
});



/***/ }),

/***/ 767:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CategoryFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FilterTag__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);











var categoryQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "Category"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ID"
          }
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "node"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "id"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "Category"
              }
            },
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "sourceTranslation"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "title"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 146,
    "source": {
      "body": "\n  query Category($id: ID!) {\n    node(id: $id) {\n      ... on Category {\n        sourceTranslation {\n          title\n        }\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var CategoryFilter =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(CategoryFilter, _PureComponent);

  function CategoryFilter() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, CategoryFilter);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(CategoryFilter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(CategoryFilter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          type = _this$props.type,
          value = _this$props.value;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Query"], {
        query: categoryQuery,
        variables: {
          id: value
        }
      }, void 0, function (_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            data = _ref.data;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__FilterTag__["a" /* default */], {
          type: type,
          loading: loading,
          onClick: onClick,
          value: data && data.node && data.node.sourceTranslation.title || value
        });
      });
    }
  }]);

  return CategoryFilter;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(CategoryFilter, "propTypes", {
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired
});



/***/ }),

/***/ 768:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FilterTag__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);











var labelQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "Label"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ID"
          }
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "node"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "id"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "Label"
              }
            },
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "name"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 108,
    "source": {
      "body": "\n  query Label($id: ID!) {\n    node(id: $id) {\n      id\n      ... on Label {\n        name\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var LabelFilter =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(LabelFilter, _PureComponent);

  function LabelFilter() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, LabelFilter);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(LabelFilter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(LabelFilter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          type = _this$props.type,
          value = _this$props.value;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Query"], {
        query: labelQuery,
        variables: {
          id: value
        }
      }, void 0, function (_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            data = _ref.data;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__FilterTag__["a" /* default */], {
          type: type,
          loading: loading,
          onClick: onClick,
          value: data && data.node && data.node.name || value
        });
      });
    }
  }]);

  return LabelFilter;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(LabelFilter, "propTypes", {
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired
});



/***/ }),

/***/ 769:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OriginFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FilterTag__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools__);












var OriginFilter =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(OriginFilter, _PureComponent);

  function OriginFilter() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, OriginFilter);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(OriginFilter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(OriginFilter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          type = _this$props.type,
          value = _this$props.value;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__FilterTag__["a" /* default */], {
        type: type,
        onClick: onClick,
        value: __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.filters.".concat(type, "-").concat(value))
      });
    }
  }]);

  return OriginFilter;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(OriginFilter, "propTypes", {
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired
});



/***/ }),

/***/ 770:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PermissionGroupFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FilterTag__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);











var permissionGroupQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "PermissionGroup"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ID"
          }
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "node"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "id"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "PermissionGroup"
              }
            },
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "name"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 128,
    "source": {
      "body": "\n  query PermissionGroup($id: ID!) {\n    node(id: $id) {\n      id\n      ... on PermissionGroup {\n        name\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var PermissionGroupFilter =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(PermissionGroupFilter, _PureComponent);

  function PermissionGroupFilter() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, PermissionGroupFilter);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(PermissionGroupFilter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(PermissionGroupFilter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          type = _this$props.type,
          value = _this$props.value;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Query"], {
        query: permissionGroupQuery,
        variables: {
          id: value
        }
      }, void 0, function (_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            data = _ref.data;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__FilterTag__["a" /* default */], {
          type: type,
          loading: loading,
          onClick: onClick,
          value: data && data.node && data.node.name || value
        });
      });
    }
  }]);

  return PermissionGroupFilter;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(PermissionGroupFilter, "propTypes", {
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired
});



/***/ }),

/***/ 771:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserSegmentFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FilterTag__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);











var userSegmentQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "PermissionGroup"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ID"
          }
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "node"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "id"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "id"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "UserSegment"
              }
            },
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "name"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 124,
    "source": {
      "body": "\n  query PermissionGroup($id: ID!) {\n    node(id: $id) {\n      id\n      ... on UserSegment {\n        name\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var UserSegmentFilter =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(UserSegmentFilter, _PureComponent);

  function UserSegmentFilter() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, UserSegmentFilter);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(UserSegmentFilter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(UserSegmentFilter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          type = _this$props.type,
          value = _this$props.value;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Query"], {
        query: userSegmentQuery,
        variables: {
          id: value
        }
      }, void 0, function (_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            data = _ref.data;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__FilterTag__["a" /* default */], {
          type: type,
          loading: loading,
          onClick: onClick,
          value: data && data.node && data.node.name || value
        });
      });
    }
  }]);

  return UserSegmentFilter;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(UserSegmentFilter, "propTypes", {
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired
});



/***/ }),

/***/ 772:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SectionFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FilterTag__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);











var sectionQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "Section"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ID"
          }
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "node"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "id"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "Section"
              }
            },
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "sourceTranslation"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "title"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 144,
    "source": {
      "body": "\n  query Section($id: ID!) {\n    node(id: $id) {\n      ... on Section {\n        sourceTranslation {\n          title\n        }\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var SectionFilter =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SectionFilter, _PureComponent);

  function SectionFilter() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, SectionFilter);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SectionFilter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SectionFilter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          type = _this$props.type,
          value = _this$props.value;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Query"], {
        query: sectionQuery,
        variables: {
          id: value
        }
      }, void 0, function (_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            data = _ref.data;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__FilterTag__["a" /* default */], {
          type: type,
          loading: loading,
          onClick: onClick,
          value: data && data.node && data.node.sourceTranslation.title || value
        });
      });
    }
  }]);

  return SectionFilter;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SectionFilter, "propTypes", {
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired
});



/***/ }),

/***/ 773:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return YesNoFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FilterTag__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools__);












var YesNoFilter =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(YesNoFilter, _PureComponent);

  function YesNoFilter() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, YesNoFilter);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(YesNoFilter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(YesNoFilter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          type = _this$props.type,
          value = _this$props.value;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__FilterTag__["a" /* default */], {
        type: type,
        onClick: onClick,
        value: value ? __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.yes") : __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.no")
      });
    }
  }]);

  return YesNoFilter;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(YesNoFilter, "propTypes", {
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});



/***/ }),

/***/ 774:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"filters":"_-src-components-FilterList-styles---filters---2-7pZ"};

/***/ }),

/***/ 775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NotificationsRecipientField__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_css__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mutations_updateDirtyStateMutation__ = __webpack_require__(143);











var dirtyStateQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "dirtyState"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "notificationRecipient"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 74,
    "source": {
      "body": "\n  query {\n    dirtyState @client {\n      notificationRecipient\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var NotificationStep =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(NotificationStep, _PureComponent);

  function NotificationStep() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, NotificationStep);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(NotificationStep).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(NotificationStep, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7_react_apollo__["Mutation"], {
        mutation: __WEBPACK_IMPORTED_MODULE_10__mutations_updateDirtyStateMutation__["b" /* updateDirtyStateMutation */]
      }, void 0, function (mutate) {
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7_react_apollo__["Query"], {
          query: dirtyStateQuery
        }, void 0, function (_ref) {
          var dirtyState = _ref.data.dirtyState;
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
            className: __WEBPACK_IMPORTED_MODULE_9__styles_css___default.a.notificationsContainer
          }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__NotificationsRecipientField__["a" /* default */], {
            value: dirtyState.notificationRecipient,
            onChange: function onChange(notificationRecipient) {
              return mutate({
                variables: {
                  data: {
                    notificationRecipient: notificationRecipient
                  }
                }
              });
            }
          }));
        });
      });
    }
  }]);

  return NotificationStep;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NotificationStep);

/***/ }),

/***/ 776:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"notificationsContainer":"_-src-components-NotificationStep-styles---notificationsContainer---2ti4i"};

/***/ }),

/***/ 777:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReviewStepRow__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_Gap__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_Gap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_Gap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_css__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FilterList__ = __webpack_require__(216);













var dirtyStateQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "dirtyState"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "filters"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "ruleName"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "frequency"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "notificationRecipient"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 140,
    "source": {
      "body": "\n  query {\n    dirtyState @client {\n      filters {\n        id\n      }\n      ruleName\n      frequency\n      notificationRecipient\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_Gap___default.a.Large, {
  vertical: true
});

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__FilterList__["a" /* default */], {});

var ReviewStep =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ReviewStep, _PureComponent);

  function ReviewStep() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ReviewStep);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ReviewStep).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ReviewStep, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7_react_apollo__["Query"], {
        query: dirtyStateQuery
      }, void 0, function (_ref) {
        var dirtyState = _ref.data.dirtyState;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment, {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("p", {
          className: __WEBPACK_IMPORTED_MODULE_11__styles_css___default.a.title
        }, void 0, __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.review.title")), _ref2, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_11__styles_css___default.a.details
        }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__ReviewStepRow__["a" /* default */], {
          label: __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.ruleName"),
          value: dirtyState.ruleName
        }), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__ReviewStepRow__["a" /* default */], {
          label: __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.step.frequency"),
          value: __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.frequency.".concat(dirtyState.frequency))
        }), dirtyState.filters.length > 0 && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__ReviewStepRow__["a" /* default */], {
          label: __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.review.filter-tags"),
          value: _ref3
        }), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__ReviewStepRow__["a" /* default */], {
          label: __WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.notifications.label"),
          value: "".concat(__WEBPACK_IMPORTED_MODULE_9__zendesk_client_i18n_tools___default()("knowledge-verification.notifications.recipient.".concat(dirtyState.notificationRecipient)))
        })));
      });
    }
  }]);

  return ReviewStep;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ReviewStep);

/***/ }),

/***/ 778:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_css__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_css__);











var ReviewStepRow =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ReviewStepRow, _Component);

  function ReviewStepRow() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ReviewStepRow);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ReviewStepRow).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ReviewStepRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          value = _this$props.value;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_9__styles_css___default.a.row
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("span", {
        className: __WEBPACK_IMPORTED_MODULE_9__styles_css___default.a.rowLabel
      }, void 0, label), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("span", {
        className: __WEBPACK_IMPORTED_MODULE_9__styles_css___default.a.rowValue
      }, void 0, value));
    }
  }]);

  return ReviewStepRow;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ReviewStepRow, "propTypes", {
  label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node
});

/* harmony default export */ __webpack_exports__["a"] = (ReviewStepRow);

/***/ }),

/***/ 779:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"_-src-components-ReviewStepRow-styles---row---3E_m1","rowLabel":"_-src-components-ReviewStepRow-styles---rowLabel---1l74X","rowValue":"_-src-components-ReviewStepRow-styles---rowValue---2Wv9k"};

/***/ }),

/***/ 780:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"_-src-components-ReviewStep-styles---title---_gqgq","details":"_-src-components-ReviewStep-styles---details---1TP0E"};

/***/ }),

/***/ 782:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Author; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_avatars__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_avatars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_avatars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_css__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_css__);












var Author =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Author, _PureComponent);

  function Author() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Author);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Author).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Author, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          avatar = _this$props.avatar,
          email = _this$props.email;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_10__styles_css___default.a.container
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_avatars__["Avatar"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("img", {
        src: avatar,
        alt: "".concat(name, " ").concat(email)
      })), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("span", {
        className: __WEBPACK_IMPORTED_MODULE_10__styles_css___default.a.label
      }, void 0, name));
    }
  }]);

  return Author;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Author, "propTypes", {
  name: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  email: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  avatar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
});



/***/ }),

/***/ 784:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_-src-components-Author-styles---container---3O6Eg","label":"_-src-components-Author-styles---label---PNB1a"};

/***/ }),

/***/ 785:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pageToCursor = function pageToCursor(page, pageSize) {
  return window.btoa("arrayconnection:".concat((page - 1) * pageSize - 1));
};

/* harmony default export */ __webpack_exports__["a"] = (pageToCursor);

/***/ }),

/***/ 786:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoResults; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_css__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools__);










var NoResults =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(NoResults, _PureComponent);

  function NoResults() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, NoResults);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(NoResults).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(NoResults, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_7__styles_css___default.a.noResults,
        "data-test-id": "article-matches-no-results"
      }, void 0, __WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools___default()("knowledge-verification.noMatchingArticlesFound"));
    }
  }]);

  return NoResults;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);



/***/ }),

/***/ 787:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchFailure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_css__);










var SearchFailure =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SearchFailure, _PureComponent);

  function SearchFailure() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, SearchFailure);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SearchFailure).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SearchFailure, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_8__styles_css___default.a.searchFailure,
        "data-test-id": "article-matches-search-failure"
      }, void 0, __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools___default()("knowledge-verification.searchFailure"));
    }
  }]);

  return SearchFailure;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);



/***/ }),

/***/ 795:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"_-src-components-NewRoute-styles---content---IfYr4","step":"_-src-components-NewRoute-styles---step---3HESA","form":"_-src-components-NewRoute-styles---form---3eJuh","buttons":"_-src-components-NewRoute-styles---buttons---LFrWu","title":"_-src-components-NewRoute-styles---title---2kHyk","wizardContainer":"_-src-components-NewRoute-styles---wizardContainer---ZT7PC","wizardStep":"_-src-components-NewRoute-styles---wizardStep---rl_km"};

/***/ }),

/***/ 796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IndexRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_chrome_lib_Chrome__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_chrome_lib_Chrome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_chrome_lib_Chrome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_guide_chrome__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendesk_guide_chrome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__zendesk_guide_chrome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_utils_lib_createBrandedUrl__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_utils_lib_createBrandedUrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_utils_lib_createBrandedUrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_css__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__IndexPage__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ErrorBoundary__ = __webpack_require__(335);
















var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Separator, {});

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__IndexPage__["a" /* default */], {});

var IndexRoute =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(IndexRoute, _PureComponent);

  function IndexRoute() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, IndexRoute);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(IndexRoute).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(IndexRoute, [{
    key: "render",
    value: function render() {
      var subdomain = Object(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__["getHelpCenter"])().route.subdomain;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_chrome_lib_Chrome___default.a, {
        brandId: Object(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__["getCurrentBrandId"])(),
        dir: __WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools___default.a.dir,
        topNav: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs, {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, "settings", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("a", {
          href: "/hc/admin/general_settings"
        }, void 0, __WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools___default()("knowledge-verification.settings"))), _ref, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, "verification", __WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools___default()("knowledge-verification.articleVerifications")))
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendesk_guide_chrome__["Sidebar"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendesk_guide_chrome__["Sidebar"].LinkItem, {
        href: __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_utils_lib_createBrandedUrl___default()(subdomain, "/hc/admin/general_settings"),
        testId: "sidebar-general-settings"
      }, void 0, __WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools___default()("knowledge-verification.hcGeneralSettings")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendesk_guide_chrome__["Sidebar"].Item, {
        active: true,
        testId: "sidebar-article-verification"
      }, void 0, __WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools___default()("knowledge-verification.articleVerifications")), Object(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__["hasFeature"])("automatic_answers") && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendesk_guide_chrome__["Sidebar"].LinkItem, {
        href: __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_utils_lib_createBrandedUrl___default()(subdomain, "/hc/admin/answer_bot"),
        testId: "sidebar-answer-bot-settings"
      }, void 0, __WEBPACK_IMPORTED_MODULE_8__zendesk_client_i18n_tools___default()("knowledge-verification.hcAnswerBotSetting"))), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendesk_guide_chrome__["ContentView"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__ErrorBoundary__["a" /* default */], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_11__styles_css___default.a.content
      }, void 0, _ref2))));
    }
  }]);

  return IndexRoute;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);



/***/ }),

/***/ 803:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"_-src-components-IndexRoute-styles---content---3T8i8"};

/***/ }),

/***/ 804:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IndexPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LoaderPanel__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BlankState__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_limits__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RuleList__ = __webpack_require__(807);












var ruleListQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "verificationRules"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "first"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "Int"
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "verificationRules"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "first"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "first"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "total"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "edges"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "node"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "name"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "frequency"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "notification"
                    },
                    "arguments": [],
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "recipient"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 257,
    "source": {
      "body": "\n  query verificationRules($first: Int) {\n    verificationRules(first: $first) {\n      total\n      edges {\n        node {\n          id\n          name\n          frequency\n          notification {\n            recipient\n          }\n        }\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__LoaderPanel__["a" /* default */], {});

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__BlankState__["a" /* default */], {});

var IndexPage =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(IndexPage, _PureComponent);

  function IndexPage() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, IndexPage);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(IndexPage).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(IndexPage, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["Query"], {
        query: ruleListQuery,
        variables: {
          first: __WEBPACK_IMPORTED_MODULE_10__constants_limits__["a" /* RULE_LIMIT */]
        }
      }, void 0, function (_ref) {
        var data = _ref.data,
            error = _ref.error,
            loading = _ref.loading;

        if (error) {
          throw error;
        }

        if (loading) {
          return _ref2;
        }

        var _data$verificationRul = data.verificationRules,
            verificationRules = _data$verificationRul === void 0 ? {
          edges: [],
          total: 0
        } : _data$verificationRul;
        var showBlankState = verificationRules.total === 0;
        return showBlankState ? _ref3 : __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__RuleList__["a" /* default */], {
          verificationRules: verificationRules
        });
      });
    }
  }]);

  return IndexPage;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);



/***/ }),

/***/ 805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlankState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_buttons__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_buttons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_buttons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__BlankState_css__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__BlankState_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__BlankState_css__);













var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("title", {}, void 0, "IMG Alert");

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("g", {
  fill: "none",
  fillRule: "evenodd"
}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("path", {
  d: "M116 61c0 32.032-25.968 58-58 58S0 93.032 0 61 25.968 3 58 3s58 25.968 58 58",
  fill: "#F0F0F0"
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("path", {
  d: "M6 21.09h16.73s-.85 13.987 5.546 20.418c6.397 6.432 11.667 5.037 11.667 5.037V23.46s-4.625-5.49-5.655-19.417c0 0-1.896 8.232 7.766 22.804 9.662 14.57 22.097 9.084 22.097 9.084C60.394 22.799 47.763 1 47.763 1",
  fill: "#F9F9F9",
  stroke: "#CCC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2"
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("path", {
  d: "M53.281 46.142c0 2.707 2.183 4.902 4.876 4.902 2.693 0 4.875-2.195 4.875-4.902h-9.75z",
  fill: "#FFF"
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("path", {
  d: "M53.281 46.142c0 2.707 2.183 4.902 4.876 4.902 2.693 0 4.875-2.195 4.875-4.902h-9.75z",
  stroke: "#CCC",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("path", {
  d: "M90.706 101.47c1.976 0 3.58-1.61 3.58-3.597 0-1.987-1.604-3.598-3.58-3.598H25.608c-1.976 0-3.578 1.61-3.578 3.598 0 1.987 1.602 3.598 3.578 3.598h65.098z",
  fill: "#F2F2F2"
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("path", {
  d: "M90.706 101.47c1.976 0 3.58-1.61 3.58-3.597 0-1.987-1.604-3.598-3.58-3.598H25.608c-1.976 0-3.578 1.61-3.578 3.598 0 1.987 1.602 3.598 3.578 3.598h65.098z",
  stroke: "#CCC",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("path", {
  d: "M58.517 58.61c16.8 0 30.417 13.692 30.417 30.582 0 0-.402 2.744 3.445 5.082H24.445c3.847-2.338 3.444-5.082 3.444-5.082 0-16.89 13.618-30.582 30.418-30.582v-6.566",
  fill: "#FFF"
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("path", {
  d: "M58.517 58.61c16.8 0 30.417 13.692 30.417 30.582 0 0-.402 2.744 3.445 5.082H24.445c3.847-2.338 3.444-5.082 3.444-5.082 0-16.89 13.618-30.582 30.418-30.582v-6.566M28.55 83.735h4.573M27.896 88.877h8.716",
  stroke: "#CCC",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("path", {
  d: "M36.088 78.147a2.36 2.36 0 0 0 1.533 2.956c1.235.39 2.55-.3 2.939-1.542 0 0 3.107-4.674 6.06-6.92 1.509-1.147 3.119-2.2 4.857-2.96 1.368-.598 2.68-.583 4.064-1.007 1.008-.31 1.722-1.166 1.722-2.244a2.35 2.35 0 0 0-2.345-2.357s-5.87-.29-11.596 4.837-7.234 9.237-7.234 9.237z",
  stroke: "#CCC",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var Bell = function Bell(props) {
  return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("svg", props, _ref2, _ref3);
};

Bell.defaultProps = {
  width: "116",
  height: "119",
  viewBox: "0 0 116 119",
  xmlns: "http://www.w3.org/2000/svg"
};


var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("br", {}, "newline");

var BlankState =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(BlankState, _PureComponent);

  function BlankState() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, BlankState);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(BlankState)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "showNewRoute", function () {
      return Object(__WEBPACK_IMPORTED_MODULE_10__utils_navigation__["g" /* showNewRoute */])();
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(BlankState, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_12__BlankState_css___default.a.blankState,
        "data-test-id": "blank-state"
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("h1", {}, void 0, __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-verification.articleVerifications")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("section", {
        className: __WEBPACK_IMPORTED_MODULE_12__BlankState_css___default.a.description
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(Bell, {
        className: __WEBPACK_IMPORTED_MODULE_12__BlankState_css___default.a.bell
      }), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("h2", {}, void 0, __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-verification.blankState.title")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("p", {}, void 0, __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default.a.format("knowledge-verification.blankState.description", {
        newline: function newline() {
          return _ref;
        }
      })), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("p", {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("a", {
        href: __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-verification.blankState.link"),
        target: "_blank"
      }, void 0, __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-verification.blankState.learnMore"))), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_buttons__["Button"], {
        "data-test-id": "add-verification-rule",
        onClick: this.showNewRoute,
        primary: true,
        size: "small"
      }, void 0, __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-verification.addVerificationRule"))));
    }
  }]);

  return BlankState;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);



/***/ }),

/***/ 806:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"description":"_-src-components-IndexRoute-BlankState---description---3Ug9z","bell":"_-src-components-IndexRoute-BlankState---bell---30gcj","blankState":"_-src-components-IndexRoute-BlankState---blankState---2KaaQ"};

/***/ }),

/***/ 807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_buttons__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_buttons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_buttons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_css__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_limits__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_tables__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_tables__);

















var RuleList =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(RuleList, _Component);

  function RuleList() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, RuleList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(RuleList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "showNewRoute", function () {
      return Object(__WEBPACK_IMPORTED_MODULE_12__utils_navigation__["g" /* showNewRoute */])();
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "showEditRoute", function (ruleId) {
      return Object(__WEBPACK_IMPORTED_MODULE_12__utils_navigation__["e" /* showEditRoute */])(ruleId);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(RuleList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var verificationRules = this.props.verificationRules;
      var reachedLimit = verificationRules.total >= __WEBPACK_IMPORTED_MODULE_14__constants_limits__["a" /* RULE_LIMIT */];
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_13__styles_css___default.a.content
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_13__styles_css___default.a.header
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("h1", {
        className: __WEBPACK_IMPORTED_MODULE_13__styles_css___default.a.title
      }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.articleVerifications")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_buttons__["Button"], {
        "data-test-id": "add-verification-rule",
        onClick: this.showNewRoute,
        primary: true,
        size: "small",
        disabled: reachedLimit,
        title: reachedLimit ? __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.ruleLimit", {
          limit: __WEBPACK_IMPORTED_MODULE_14__constants_limits__["a" /* RULE_LIMIT */]
        }) : "",
        "aria-label": __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.addVerificationRule")
      }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.add"))), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("p", {}, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.listDescription")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_13__styles_css___default.a.table
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_tables__["Table"], {
        size: "large",
        "data-test-id": "rule-list"
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_tables__["Head"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_tables__["HeaderRow"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_tables__["HeaderCell"], {
        width: "50%"
      }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.ruleListTable.name")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_tables__["HeaderCell"], {
        width: "30%"
      }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.step.frequency")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_tables__["HeaderCell"], {
        width: "20%"
      }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.ruleListTable.recipient")))), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_tables__["Body"], {}, void 0, verificationRules.edges.map(function (_ref) {
        var node = _ref.node;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_tables__["Row"], {
          style: {
            cursor: "pointer"
          },
          onClick: function onClick() {
            return _this2.showEditRoute(node.id);
          }
        }, node.id, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_tables__["Cell"], {
          width: "50%",
          className: __WEBPACK_IMPORTED_MODULE_13__styles_css___default.a.cell
        }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("span", {
          className: __WEBPACK_IMPORTED_MODULE_13__styles_css___default.a.ellipsis
        }, void 0, node.name)), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_tables__["Cell"], {
          width: "30%",
          className: __WEBPACK_IMPORTED_MODULE_13__styles_css___default.a.cell
        }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.frequency.".concat(node.frequency))), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_tables__["Cell"], {
          width: "20%",
          className: __WEBPACK_IMPORTED_MODULE_13__styles_css___default.a.cell
        }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.notifications.recipient.".concat(node.notification.recipient))));
      })))));
    }
  }]);

  return RuleList;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(RuleList, "propTypes", {
  verificationRules: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object.isRequired
});

/* harmony default export */ __webpack_exports__["a"] = (RuleList);

/***/ }),

/***/ 808:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table":"_-src-components-RuleList-styles---table---1W2_m","ellipsis":"_-src-components-RuleList-styles---ellipsis---1tJ23","cell":"_-src-components-RuleList-styles---cell---2FEmF","title":"_-src-components-RuleList-styles---title---ayT7Z","header":"_-src-components-RuleList-styles---header---2vUC7"};

/***/ }),

/***/ 813:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_utils_lib_ErrorHandler__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_utils_lib_ErrorHandler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_utils_lib_ErrorHandler__);

var errorHandler = new __WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_utils_lib_ErrorHandler___default.a();

var notifyError = function notifyError(component, error) {
  errorHandler.notify({
    error: error,
    context: {
      version: "no version provided",
      component: "verification:".concat(component),
      details: error.details
    }
  });
  console.error(component, error);
};

/* harmony default export */ __webpack_exports__["a"] = (notifyError);

/***/ }),

/***/ 816:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__LoadingOverlay__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ErrorBoundary__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__state_createFilter__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__EditForm__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ArticleMatches__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__state_idFilters__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__state_yesNoFilters__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_getFilterType__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__LoaderPanel__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__styles_css__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__styles_css__);


























var verificationRuleQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "VerificationRule"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "id"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ID"
          }
        }
      }
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "verificationRule"
        },
        "name": {
          "kind": "Name",
          "value": "node"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "id"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "id"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "InlineFragment",
            "typeCondition": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "VerificationRule"
              }
            },
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "name"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "filter"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "InlineFragment",
                    "typeCondition": {
                      "kind": "NamedType",
                      "name": {
                        "kind": "Name",
                        "value": "VerificationRuleAuthorFilterTerm"
                      }
                    },
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "author"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                          "kind": "SelectionSet",
                          "selections": [{
                            "kind": "Field",
                            "name": {
                              "kind": "Name",
                              "value": "id"
                            },
                            "arguments": [],
                            "directives": []
                          }]
                        }
                      }]
                    }
                  }, {
                    "kind": "InlineFragment",
                    "typeCondition": {
                      "kind": "NamedType",
                      "name": {
                        "kind": "Name",
                        "value": "VerificationRuleBrandFilterTerm"
                      }
                    },
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "brand"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                          "kind": "SelectionSet",
                          "selections": [{
                            "kind": "Field",
                            "name": {
                              "kind": "Name",
                              "value": "id"
                            },
                            "arguments": [],
                            "directives": []
                          }]
                        }
                      }]
                    }
                  }, {
                    "kind": "InlineFragment",
                    "typeCondition": {
                      "kind": "NamedType",
                      "name": {
                        "kind": "Name",
                        "value": "VerificationRuleLabelFilterTerm"
                      }
                    },
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "label"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                          "kind": "SelectionSet",
                          "selections": [{
                            "kind": "Field",
                            "name": {
                              "kind": "Name",
                              "value": "id"
                            },
                            "arguments": [],
                            "directives": []
                          }]
                        }
                      }]
                    }
                  }, {
                    "kind": "InlineFragment",
                    "typeCondition": {
                      "kind": "NamedType",
                      "name": {
                        "kind": "Name",
                        "value": "VerificationRulePermissionGroupFilterTerm"
                      }
                    },
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "permissionGroup"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                          "kind": "SelectionSet",
                          "selections": [{
                            "kind": "Field",
                            "name": {
                              "kind": "Name",
                              "value": "id"
                            },
                            "arguments": [],
                            "directives": []
                          }]
                        }
                      }]
                    }
                  }, {
                    "kind": "InlineFragment",
                    "typeCondition": {
                      "kind": "NamedType",
                      "name": {
                        "kind": "Name",
                        "value": "VerificationRuleUserSegmentFilterTerm"
                      }
                    },
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "userSegment"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                          "kind": "SelectionSet",
                          "selections": [{
                            "kind": "Field",
                            "name": {
                              "kind": "Name",
                              "value": "id"
                            },
                            "arguments": [],
                            "directives": []
                          }]
                        }
                      }]
                    }
                  }, {
                    "kind": "InlineFragment",
                    "typeCondition": {
                      "kind": "NamedType",
                      "name": {
                        "kind": "Name",
                        "value": "VerificationRuleCategoryFilterTerm"
                      }
                    },
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "category"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                          "kind": "SelectionSet",
                          "selections": [{
                            "kind": "Field",
                            "name": {
                              "kind": "Name",
                              "value": "id"
                            },
                            "arguments": [],
                            "directives": []
                          }]
                        }
                      }]
                    }
                  }, {
                    "kind": "InlineFragment",
                    "typeCondition": {
                      "kind": "NamedType",
                      "name": {
                        "kind": "Name",
                        "value": "VerificationRuleSectionFilterTerm"
                      }
                    },
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "section"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                          "kind": "SelectionSet",
                          "selections": [{
                            "kind": "Field",
                            "name": {
                              "kind": "Name",
                              "value": "id"
                            },
                            "arguments": [],
                            "directives": []
                          }]
                        }
                      }]
                    }
                  }, {
                    "kind": "InlineFragment",
                    "typeCondition": {
                      "kind": "NamedType",
                      "name": {
                        "kind": "Name",
                        "value": "VerificationRuleIsOpenForCommentFilterTerm"
                      }
                    },
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "isOpenForComment"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }, {
                    "kind": "InlineFragment",
                    "typeCondition": {
                      "kind": "NamedType",
                      "name": {
                        "kind": "Name",
                        "value": "VerificationRuleIsPromotedFilterTerm"
                      }
                    },
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "isPromoted"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }, {
                    "kind": "InlineFragment",
                    "typeCondition": {
                      "kind": "NamedType",
                      "name": {
                        "kind": "Name",
                        "value": "VerificationRuleOriginFilterTerm"
                      }
                    },
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "origin"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }, {
                    "kind": "InlineFragment",
                    "typeCondition": {
                      "kind": "NamedType",
                      "name": {
                        "kind": "Name",
                        "value": "VerificationRuleCreatedFilterTerm"
                      }
                    },
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "created"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }, {
                    "kind": "InlineFragment",
                    "typeCondition": {
                      "kind": "NamedType",
                      "name": {
                        "kind": "Name",
                        "value": "VerificationRuleUpdatedFilterTerm"
                      }
                    },
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "updated"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }]
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "frequency"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "notification"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "recipient"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 1537,
    "source": {
      "body": "\n  query VerificationRule($id: ID!) {\n    verificationRule: node(id: $id) {\n      ... on VerificationRule {\n        id\n        name\n        filter {\n          ... on VerificationRuleAuthorFilterTerm {\n            author {\n              id\n            }\n          }\n          ... on VerificationRuleBrandFilterTerm {\n            brand {\n              id\n            }\n          }\n          ... on VerificationRuleLabelFilterTerm {\n            label {\n              id\n            }\n          }\n          ... on VerificationRulePermissionGroupFilterTerm {\n            permissionGroup {\n              id\n            }\n          }\n          ... on VerificationRuleUserSegmentFilterTerm {\n            userSegment {\n              id\n            }\n          }\n          ... on VerificationRuleCategoryFilterTerm {\n            category {\n              id\n            }\n          }\n          ... on VerificationRuleSectionFilterTerm {\n            section {\n              id\n            }\n          }\n          ... on VerificationRuleIsOpenForCommentFilterTerm {\n            isOpenForComment\n          }\n          ... on VerificationRuleIsPromotedFilterTerm {\n            isPromoted\n          }\n          ... on VerificationRuleOriginFilterTerm {\n            origin\n          }\n          ... on VerificationRuleCreatedFilterTerm {\n            created\n          }\n          ... on VerificationRuleUpdatedFilterTerm {\n            updated\n          }\n        }\n        frequency\n        notification {\n          recipient\n        }\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Separator, {});

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Separator, {});

var _ref4 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_24__LoaderPanel__["a" /* default */], {
  testId: "loader"
});

var _ref6 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_20__ArticleMatches__["a" /* default */], {});

var EditRoute =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(EditRoute, _Component);

  function EditRoute() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, EditRoute);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(EditRoute)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "showIndex", function (e) {
      e.preventDefault();
      Object(__WEBPACK_IMPORTED_MODULE_14__utils_navigation__["f" /* showIndex */])();
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(EditRoute, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          isDuplicate = _this$props.isDuplicate;

      var _ref5 =
      /*#__PURE__*/
      __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_19__EditForm__["a" /* default */], {
        id: id,
        isDuplicate: isDuplicate
      });

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome___default.a, {
        brandId: Object(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__["getCurrentBrandId"])(),
        dir: __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default.a.dir,
        topNav: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs, {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, "settings", __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("a", {
          href: "/hc/admin/general_settings"
        }, void 0, __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default()("knowledge-verification.settings"))), _ref, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, "verification", __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("a", {
          href: "/knowledge/verification/",
          onClick: this.showIndex
        }, void 0, __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default()("knowledge-verification.articleVerifications"))), _ref2, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, "editRule", __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default()("knowledge-verification.editRule")))
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__ErrorBoundary__["a" /* default */], {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Query"], {
        query: verificationRuleQuery,
        variables: {
          id: id
        }
      }, void 0, function (_ref3) {
        var data = _ref3.data,
            loading = _ref3.loading,
            error = _ref3.error,
            client = _ref3.client;

        if (error) {
          throw error;
        }

        if (loading) {
          return _ref4;
        }

        if (!data.verificationRule) {
          return Object(__WEBPACK_IMPORTED_MODULE_14__utils_navigation__["f" /* showIndex */])();
        }

        var _data$verificationRul = data.verificationRule,
            name = _data$verificationRul.name,
            recipient = _data$verificationRul.notification.recipient,
            frequency = _data$verificationRul.frequency,
            filter = _data$verificationRul.filter;
        var initialEditState = {
          ruleName: isDuplicate ? __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default()("knowledge-verification.duplicateTitle", {
            name: name
          }) : name,
          frequency: frequency,
          notificationRecipient: recipient,
          filters: filter.map(function (filterTerm) {
            var type = Object(__WEBPACK_IMPORTED_MODULE_23__utils_getFilterType__["a" /* default */])(filterTerm);

            if (__WEBPACK_IMPORTED_MODULE_21__state_idFilters__["a" /* default */].includes(type)) {
              return Object(__WEBPACK_IMPORTED_MODULE_18__state_createFilter__["a" /* default */])({
                type: type,
                value: filterTerm[type].id
              });
            }

            if (__WEBPACK_IMPORTED_MODULE_22__state_yesNoFilters__["a" /* default */].includes(type) || ["origin", "created", "updated"].includes(type)) {
              return Object(__WEBPACK_IMPORTED_MODULE_18__state_createFilter__["a" /* default */])({
                type: type,
                value: filterTerm[type]
              });
            }

            return false;
          }).filter(Boolean)
        };
        client.cache.writeData({
          data: {
            initialEditState: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({
              __typename: "InitialState"
            }, initialEditState),
            dirtyState: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({
              __typename: "DirtyState"
            }, initialEditState)
          }
        });
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__LoadingOverlay__["a" /* default */], {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_25__styles_css___default.a.container
        }, void 0, _ref5, _ref6));
      })));
    }
  }]);

  return EditRoute;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(EditRoute, "propTypes", {
  id: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired,
  isDuplicate: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool
});



/***/ }),

/***/ 817:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_Gap__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_Gap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_Gap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FrequencyField__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FilterMenu__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NotificationsRecipientField__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mutations_updateDirtyStateMutation__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RuleNameClickToEdit__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__state_validateRuleName__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CreateVerificationRuleMutation__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_buttons__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_buttons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_buttons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_css__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FilterList__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__EditSplitButton__ = __webpack_require__(825);























var dirtyStateQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "dirtyState"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "notificationRecipient"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "ruleName"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "frequency"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 105,
    "source": {
      "body": "\n  query {\n    dirtyState @client {\n      notificationRecipient\n      ruleName\n      frequency\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_Gap___default.a.Huge, {
  vertical: true
});

var _ref4 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_Gap___default.a.Huge, {
  vertical: true
});

var _ref5 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__FilterMenu__["a" /* default */], {});

var _ref6 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_Gap___default.a.Large, {
  vertical: true
});

var _ref7 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_21__FilterList__["a" /* default */], {
  removable: true
});

var EditForm =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(EditForm, _Component);

  function EditForm() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, EditForm);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(EditForm).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(EditForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          isDuplicate = _this$props.isDuplicate;

      var _ref2 =
      /*#__PURE__*/
      __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_22__EditSplitButton__["a" /* default */], {
        id: id
      });

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Mutation"], {
        mutation: __WEBPACK_IMPORTED_MODULE_14__mutations_updateDirtyStateMutation__["b" /* updateDirtyStateMutation */]
      }, void 0, function (mutate) {
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Query"], {
          query: dirtyStateQuery
        }, void 0, function (_ref) {
          var dirtyState = _ref.data.dirtyState;
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
            className: __WEBPACK_IMPORTED_MODULE_20__styles_css___default.a.container
          }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
            className: __WEBPACK_IMPORTED_MODULE_20__styles_css___default.a.header
          }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
            className: __WEBPACK_IMPORTED_MODULE_20__styles_css___default.a.ruleNameContainer
          }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__RuleNameClickToEdit__["a" /* default */], {
            value: dirtyState.ruleName,
            onSubmit: function onSubmit(value) {
              mutate({
                variables: {
                  data: {
                    ruleName: value
                  }
                }
              });
              return Object(__WEBPACK_IMPORTED_MODULE_16__state_validateRuleName__["a" /* default */])(value);
            }
          })), isDuplicate ? __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_18__CreateVerificationRuleMutation__["a" /* default */], {}, void 0, function (mutate) {
            return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_19__zendeskgarden_react_buttons__["Button"], {
              size: "small",
              primary: true,
              onClick: mutate
            }, void 0, __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools___default()("knowledge-verification.create"));
          }) : _ref2), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
            className: __WEBPACK_IMPORTED_MODULE_20__styles_css___default.a.form
          }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
            className: __WEBPACK_IMPORTED_MODULE_20__styles_css___default.a.dropdown
          }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__FrequencyField__["a" /* default */], {
            selectedKey: dirtyState.frequency,
            onChange: function onChange(key) {
              return mutate({
                variables: {
                  data: {
                    frequency: key
                  }
                }
              });
            }
          })), _ref3, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
            className: __WEBPACK_IMPORTED_MODULE_20__styles_css___default.a.dropdown
          }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__NotificationsRecipientField__["a" /* default */], {
            value: dirtyState.notificationRecipient,
            onChange: function onChange(notificationRecipient) {
              return mutate({
                variables: {
                  data: {
                    notificationRecipient: notificationRecipient
                  }
                }
              });
            }
          })), _ref4, _ref5, _ref6, _ref7));
        });
      });
    }
  }]);

  return EditForm;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(EditForm, "propTypes", {
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  isDuplicate: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});



/***/ }),

/***/ 818:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RuleNameClickToEdit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_textfields__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_textfields___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_textfields__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__state_validateRuleName__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_components_lib_ClickToEdit__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_components_lib_ClickToEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_components_lib_ClickToEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_css__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_css__);















var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_components_lib_ClickToEdit__["EditIcon"], {
  size: 18
});

var RuleNameClickToEdit =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(RuleNameClickToEdit, _Component);

  function RuleNameClickToEdit() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, RuleNameClickToEdit);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(RuleNameClickToEdit).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(RuleNameClickToEdit, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onSubmit = _this$props.onSubmit,
          value = _this$props.value;
      var showValidation = !Object(__WEBPACK_IMPORTED_MODULE_11__state_validateRuleName__["a" /* default */])(value);
      var validation = showValidation ? "error" : "none";
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_components_lib_ClickToEdit__["ClickToEdit"], {
        input: function input(getInputProps) {
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_textfields__["TextField"], {}, void 0, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_textfields__["Input"], getInputProps({
            "data-test-id": "rule-name-input",
            placeholder: __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.ruleNamePlaceholder"),
            validation: validation
          })), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_textfields__["Message"], {
            "data-test-id": "rule-name-validation",
            validation: validation,
            style: {
              display: showValidation ? "inherit" : "none"
            }
          }, void 0, __WEBPACK_IMPORTED_MODULE_10__zendesk_client_i18n_tools___default()("knowledge-verification.ruleNameMissing")));
        },
        placeholder: function placeholder(getPlaceholderProps) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_components_lib_ClickToEdit__["Placeholder"], getPlaceholderProps({
            "data-test-id": "rule-name-input-placeholder",
            className: __WEBPACK_IMPORTED_MODULE_13__styles_css___default.a.placeholder
          }), value, _ref);
        },
        value: value,
        onSubmit: onSubmit
      });
    }
  }]);

  return RuleNameClickToEdit;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(RuleNameClickToEdit, "propTypes", {
  onSubmit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired
});



/***/ }),

/***/ 823:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"placeholder":"_-src-components-RuleNameClickToEdit-styles---placeholder---VhAuW","form":"_-src-components-RuleNameClickToEdit-styles---form---1ceIO"};

/***/ }),

/***/ 824:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_-src-components-EditForm-styles---container---1NoTb","form":"_-src-components-EditForm-styles---form---2N60I","header":"_-src-components-EditForm-styles---header---6Fu9w","dropdown":"_-src-components-EditForm-styles---dropdown---yNzvZ","ruleNameContainer":"_-src-components-EditForm-styles---ruleNameContainer---3w9Ww"};

/***/ }),

/***/ 825:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditSplitButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_menus__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DeleteVerificationRuleMutation__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__UpdateVerificationRuleMutation__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_components_lib_ModalDialog__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_components_lib_ModalDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_components_lib_ModalDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_css__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_buttons__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_buttons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_buttons__);



















var EditSplitButton =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(EditSplitButton, _Component);

  function EditSplitButton() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, EditSplitButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(EditSplitButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      isOpen: false,
      showDeleteConfirmation: false
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "showDuplicateRoute", function (ruleId) {
      return Object(__WEBPACK_IMPORTED_MODULE_11__utils_navigation__["d" /* showDuplicateRoute */])(ruleId);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onStateChange", function (newState) {
      return _this.setState(newState);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "showDeleteConfirmation", function () {
      return _this.setState({
        showDeleteConfirmation: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "hideDeleteConfirmation", function () {
      return _this.setState({
        showDeleteConfirmation: false
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(EditSplitButton, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var id = this.props.id;
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          showDeleteConfirmation = _this$state.showDeleteConfirmation;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment, {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__UpdateVerificationRuleMutation__["a" /* default */], {
        id: id
      }, void 0, function (updateVerification) {
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_buttons__["ButtonGroupView"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_buttons__["Button"], {
          "data-test-id": "save-verification-rule",
          size: "small",
          primary: true,
          onClick: updateVerification
        }, void 0, __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default()("knowledge-verification.save")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_menus__["Menu"], {
          isOpen: isOpen,
          placement: "top-end",
          onChange: function onChange(selectedKey) {
            switch (selectedKey) {
              case "save":
                return updateVerification();

              case "duplicate":
                return _this2.showDuplicateRoute(id);

              case "delete":
                return _this2.showDeleteConfirmation();
            }
          },
          onStateChange: _this2.onStateChange,
          trigger: function trigger(_ref) {
            var ref = _ref.ref;
            return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_buttons__["ChevronButton"], {
              "data-test-id": "edit-menu-trigger",
              size: "small",
              primary: true,
              buttonRef: ref,
              rotated: isOpen,
              active: isOpen,
              "aria-label": "Other Options"
            });
          }
        }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_menus__["Item"], {
          "data-test-id": "save-verification-rule"
        }, "save", __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default()("knowledge-verification.save")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_menus__["Item"], {
          "data-test-id": "duplicate-verification-rule"
        }, "duplicate", __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default()("knowledge-verification.duplicate")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_menus__["Item"], {
          "data-test-id": "delete-verification-rule"
        }, "delete", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("span", {
          className: __WEBPACK_IMPORTED_MODULE_16__styles_css___default.a.deleteItem
        }, void 0, __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default()("knowledge-verification.delete")))));
      }), showDeleteConfirmation && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__DeleteVerificationRuleMutation__["a" /* default */], {
        id: id
      }, void 0, function (deleteVerification) {
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_components_lib_ModalDialog___default.a, {
          testId: "deleteConfirmationModal",
          visible: true,
          danger: true,
          body: __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default()("knowledge-verification.deleteRuleConfirmation"),
          onSubmit: deleteVerification,
          onCancel: _this2.hideDeleteConfirmation
        });
      }));
    }
  }]);

  return EditSplitButton;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(EditSplitButton, "Item", __WEBPACK_IMPORTED_MODULE_10__zendeskgarden_react_menus__["Item"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(EditSplitButton, "propTypes", {
  id: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired
});



/***/ }),

/***/ 826:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteVerificationRuleMutation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mutations_verificationRuleMutations__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_components_lib_Notifications_Connected__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_components_lib_Notifications_Connected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_components_lib_Notifications_Connected__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__MutationWithOverlay__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools__);
















var DeleteVerificationRuleMutation =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(DeleteVerificationRuleMutation, _PureComponent);

  function DeleteVerificationRuleMutation() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, DeleteVerificationRuleMutation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(DeleteVerificationRuleMutation)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onDeleted", function (_ref) {
      var success = _ref.deleteVerificationRule.success;

      if (success) {
        Object(__WEBPACK_IMPORTED_MODULE_11__utils_navigation__["f" /* showIndex */])({
          skipDirtyCheck: true
        });
        __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_components_lib_Notifications_Connected__["notifications"].showSuccess({
          message: __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-verification.notification.verificationRuleDelete.message")
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_components_lib_Notifications_Connected__["notifications"].showError({
          message: __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-verification.notification.verificationRuleDelete.failed")
        });
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(DeleteVerificationRuleMutation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          id = _this$props.id;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__MutationWithOverlay__["a" /* default */], {
        mutation: __WEBPACK_IMPORTED_MODULE_10__mutations_verificationRuleMutations__["b" /* deleteVerificationRuleMutation */],
        refetchQueries: ["verificationRules"],
        variables: {
          id: id
        },
        awaitRefetchQueries: true,
        onCompleted: this.onDeleted
      }, void 0, children);
    }
  }]);

  return DeleteVerificationRuleMutation;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(DeleteVerificationRuleMutation, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired
});



/***/ }),

/***/ 827:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpdateVerificationRuleMutation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mutations_verificationRuleMutations__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_navigation__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_components_lib_Notifications_Connected__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_components_lib_Notifications_Connected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_components_lib_Notifications_Connected__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__MutationWithOverlay__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_prepareFilters__ = __webpack_require__(218);

















var dirtyStateQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "dirtyState"
        },
        "arguments": [],
        "directives": [{
          "kind": "Directive",
          "name": {
            "kind": "Name",
            "value": "client"
          },
          "arguments": []
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "ruleName"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "frequency"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "filters"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "type"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "value"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "notificationRecipient"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 156,
    "source": {
      "body": "\n  query {\n    dirtyState @client {\n      ruleName\n      frequency\n      filters {\n        type\n        value\n      }\n      notificationRecipient\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

var UpdateVerificationRuleMutation =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(UpdateVerificationRuleMutation, _PureComponent);

  function UpdateVerificationRuleMutation() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, UpdateVerificationRuleMutation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(UpdateVerificationRuleMutation)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onUpdated", function (_ref) {
      var success = _ref.updateVerificationRule.success;

      if (success) {
        Object(__WEBPACK_IMPORTED_MODULE_12__utils_navigation__["f" /* showIndex */])({
          skipDirtyCheck: true
        });
        __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_components_lib_Notifications_Connected__["notifications"].showSuccess({
          message: __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-verification.notification.verificationRuleUpdate.message")
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_components_lib_Notifications_Connected__["notifications"].showError({
          message: __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-verification.notification.verificationRuleUpdate.failed")
        });
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(UpdateVerificationRuleMutation, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          id = _this$props.id;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"], {
        query: dirtyStateQuery
      }, void 0, function (_ref2) {
        var dirtyState = _ref2.data.dirtyState;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__MutationWithOverlay__["a" /* default */], {
          mutation: __WEBPACK_IMPORTED_MODULE_10__mutations_verificationRuleMutations__["c" /* updateVerificationRuleMutation */],
          refetchQueries: ["verificationRules", "VerificationRule"],
          variables: {
            id: id,
            name: dirtyState.ruleName,
            filter: Object(__WEBPACK_IMPORTED_MODULE_16__utils_prepareFilters__["a" /* default */])(dirtyState.filters),
            frequency: dirtyState.frequency,
            notification: {
              recipient: dirtyState.notificationRecipient
            }
          },
          awaitRefetchQueries: true,
          onCompleted: _this2.onUpdated
        }, void 0, children);
      });
    }
  }]);

  return UpdateVerificationRuleMutation;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(UpdateVerificationRuleMutation, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired
});



/***/ }),

/***/ 828:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"deleteItem":"_-src-components-EditSplitButton-styles---deleteItem---1HFvo"};

/***/ }),

/***/ 829:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getFilterType = function getFilterType(filterTerm) {
  return filterTerm.__typename.replace(/VerificationRule(\w)(\w+)FilterTerm/, function ($0, $1, $2) {
    return $1.toLowerCase() + $2;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getFilterType);

/***/ }),

/***/ 830:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_-src-components-EditRoute-styles---container---xsbOo"};

/***/ }),

/***/ 881:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations_addFilterMutation__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_completeStepMutation__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_gotoPreviousStepMutation__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_removeFilterMutation__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations_updateDirtyStateMutation__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations_updateArticleMatchesPageMutation__ = __webpack_require__(330);






var resolvers = {
  Mutation: {
    addFilter: __WEBPACK_IMPORTED_MODULE_0__mutations_addFilterMutation__["a" /* addFilter */],
    completeStep: __WEBPACK_IMPORTED_MODULE_1__mutations_completeStepMutation__["a" /* completeStep */],
    gotoPreviousStep: __WEBPACK_IMPORTED_MODULE_2__mutations_gotoPreviousStepMutation__["a" /* gotoPreviousStep */],
    removeFilter: __WEBPACK_IMPORTED_MODULE_3__mutations_removeFilterMutation__["a" /* removeFilter */],
    updateDirtyState: __WEBPACK_IMPORTED_MODULE_4__mutations_updateDirtyStateMutation__["a" /* updateDirtyState */],
    updateArticleMatchesPage: __WEBPACK_IMPORTED_MODULE_5__mutations_updateArticleMatchesPageMutation__["a" /* updateArticleMatchesPage */]
  }
};
/* harmony default export */ __webpack_exports__["a"] = (resolvers);

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

module.exports = {"__schema":{"types":[{"kind":"INTERFACE","name":"Node","possibleTypes":[{"name":"Article"},{"name":"User"},{"name":"Brand"},{"name":"Category"},{"name":"Section"},{"name":"Label"},{"name":"PermissionGroup"},{"name":"UserSegment"},{"name":"VerificationRule"}]},{"kind":"UNION","name":"VerificationRuleFilterTerm","possibleTypes":[{"name":"VerificationRuleAuthorFilterTerm"},{"name":"VerificationRuleBrandFilterTerm"},{"name":"VerificationRuleCategoryFilterTerm"},{"name":"VerificationRuleLabelFilterTerm"},{"name":"VerificationRuleOriginFilterTerm"},{"name":"VerificationRulePermissionGroupFilterTerm"},{"name":"VerificationRuleSectionFilterTerm"},{"name":"VerificationRuleUserSegmentFilterTerm"},{"name":"VerificationRuleIsOpenForCommentFilterTerm"},{"name":"VerificationRuleIsOutOfDateFilterTerm"},{"name":"VerificationRuleIsPromotedFilterTerm"},{"name":"VerificationRuleCreatedFilterTerm"},{"name":"VerificationRuleUpdatedFilterTerm"}]},{"kind":"INTERFACE","name":"MutationResponse","possibleTypes":[{"name":"CreateVerificationRuleMutationResponse"},{"name":"DeleteVerificationRuleMutationResponse"},{"name":"UpdateVerificationRuleMutationResponse"}]}]}}

/***/ }),

/***/ 892:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apollo_client__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_defaults__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isequal__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_pick__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_pick__);




var dirtyStateQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "variableDefinitions": [],
    "directives": [{
      "kind": "Directive",
      "name": {
        "kind": "Name",
        "value": "client"
      },
      "arguments": []
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "initialEditState"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "ruleName"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "frequency"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "filters"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "notificationRecipient"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "dirtyState"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "ruleName"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "frequency"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "filters"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "notificationRecipient"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 221,
    "source": {
      "body": "\n  query @client {\n    initialEditState {\n      ruleName\n      frequency\n      filters\n      notificationRecipient\n    }\n    dirtyState {\n      ruleName\n      frequency\n      filters\n      notificationRecipient\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var keys = Object.keys(__WEBPACK_IMPORTED_MODULE_1__state_defaults__["b" /* initialEditState */]);

var isDirty = function isDirty() {
  var cache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0__apollo_client__["a" /* cache */];

  var _cache$readQuery = cache.readQuery({
    query: dirtyStateQuery
  }),
      initialEditState = _cache$readQuery.initialEditState,
      dirtyState = _cache$readQuery.dirtyState;

  return !__WEBPACK_IMPORTED_MODULE_2_lodash_isequal___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_pick___default()(initialEditState, keys), __WEBPACK_IMPORTED_MODULE_3_lodash_pick___default()(dirtyState, keys));
};

/* harmony default export */ __webpack_exports__["a"] = (isDirty);

/***/ }),

/***/ 895:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clearState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apollo_client__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_defaults__ = __webpack_require__(235);



var clearState = function clearState() {
  var cache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__apollo_client__["a" /* cache */];
  cache.writeData({
    data: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, __WEBPACK_IMPORTED_MODULE_2__state_defaults__["a" /* default */])
  });
};
/* harmony default export */ __webpack_exports__["a"] = (clearState);

/***/ }),

/***/ 896:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var canAccessVerification = function canAccessVerification(_ref) {
  var features = _ref.features,
      entitlement = _ref.entitlement;
  return features.includes("knowledge_bank_verification") && ["admin", "manager"].includes(entitlement);
};

/* harmony default export */ __webpack_exports__["a"] = (canAccessVerification);

/***/ }),

/***/ 907:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[383]);


// WEBPACK FOOTER //
// app-013a9e8b45afce06d360.v2.js